import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Badge,
  FormGroup
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import ClientesInfo from "./ClientesInfo";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import * as XLSX from "xlsx";
import TextField from "@material-ui/core/TextField";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import ListadoAreasClientes from "../AreasClientes/ListadoAreasClientes";

function ListadoClientes() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_GRUPOS = process.env.REACT_APP_URL_GRUPOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_BONIFICACIONES_RECURRENTES = process.env.REACT_APP_URL_BONIFICACIONES_RECURRENTES;
  const URL_CONCEPTOS_BONIFICACIONES = process.env.REACT_APP_URL_CONCEPTOS_BONIFICACIONES;
  const URL_CUENTAS_CLIENTES = process.env.REACT_APP_URL_CUENTAS_CLIENTES;
  const URL_COLABORADORES_CLIENTES = process.env.REACT_APP_URL_COLABORADORES_CLIENTES;
  const URL_COLABORADORES_TALLAS = process.env.REACT_APP_URL_COLABORADORES_TALLAS;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;
  const URL_DEPARTAMENTOS = process.env.REACT_APP_URL_DEPARTAMENTOS;
  const URL_SUBDEPARTAMENTOS = process.env.REACT_APP_URL_SUBDEPARTAMENTOS;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_AREAS_CLIENTES = process.env.REACT_APP_URL_AREAS_CLIENTES;
  const URL_VARIANTES_TALLAS = process.env.REACT_APP_URL_VARIANTES_TALLAS;

  const [clientes, setClientes] = useState([]);
  const [clienteEdit, setClienteEdit] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [selectedGrupo, setSelectedGrupo] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");
  const [idPassword, setIdPassword] = useState("");
  const [idEditCliente, setIdEditCliente] = useState("");
  const [selectedGrupoEdit, setSelectedGrupoEdit] = useState("");
  const [nombre_comercial, setNombreComercial] = useState("");
  const [razon_social, setRazonSocial] = useState("");
  const [RFC, setRFC] = useState("");
  const [calle, setCalle] = useState("");
  const [numero_ext, setNumeroExt] = useState("");
  const [numero_int, setNumeroInt] = useState("");
  const [delegacion, setDelegacion] = useState("");
  const [estado, setEstado] = useState("");
  const [pais, setPais] = useState("");
  const [cp, setCP] = useState("");
  const [colonia, setColonia] = useState("");
  const [codigo, setCodigo] = useState("");
  const [numero, setNumero] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [emailViejo, setEmailViejo] = useState("");
  const [idInfo, setIdInfo] = useState("");
  const [plazo, setPlazo] = useState("");
  const [selectedContacto, setSelectedContacto] = useState("");
  const [selectedContactoName, setSelectedContactoName] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [condicionesCotizacion, setCondicionesCotizacion] = useState("");
  const [ultimo_pago, setUltimoPago] = useState("");
  const [forma_pago, setFormaPago] = useState("");
  const [regFiscal, setRegFiscal] = useState("");
  const [usoCFDI, setusoCFDI] = useState("");
  const [formaPagoSAT, setFormaPagoSAT] = useState("");
  const [condicionesPagoSAT, setCondicionesPagoSAT] = useState("");
  const [metodoPagoSAT, setMetodoPagoSAT] = useState("");
  const [selected_grupo_name, setSelectedGrupoName] = useState("");
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [cuentas, setCuentas] = useState([]);
  const [idClienteCuenta, setIdClienteCuenta] = useState("");

  const [modalCuenta, setModalCuenta] = useState(false);
  const toggleCuenta = () => setModalCuenta(!modalCuenta);

  const [mostrarFormularioNuevo, setMostrarFormularioNuevo] = useState(false);
  const [colaboradoresCliente, setColaboradoresCliente] = useState([]);
  const [idClienteCol, setIdClienteCol] = useState("");

  const [modalColaboradores, setModalColaboradores] = useState(false);
  const toggleColaboradores = () => setModalColaboradores(!modalColaboradores);
  const [departamentos, setDepartamentos] = useState([]);
  const [subDepartamentos, setSubDepartamentos] = useState([]);
  const [mostrarSubTallas, setMostrarSubTallas] = useState({});
  const [colaboradoresTallasNuevos, setColaboradoresTallasNuevos] = useState(
    {}
  );
  const [tallas, setTallas] = useState([]);
  const [colaboradoresTallasExistentes, setColaboradoresTallasExistentes] =
    useState({});
  const [mostrarSubTallasEdit, setMostrarSubTallasEdit] = useState({});
  const [areasClientes, setAreasClientes] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState("");
  const [selectedCliente, setSelectedCliente] = useState("");

  const [modalArchivo, setModalArchivo] = useState(false);
  const toggleArchivo = () => setModalArchivo(!modalArchivo);
  const [conteoIgnorados, setConteoIgnorados] = useState({
  sinNombre: 0,
  sinArea: 0,
  sinDepartamento: 0,
});

  const [modalArchivoTallas, setModalArchivoTallas] = useState(false);
  const toggleArchivoTallas = () => setModalArchivoTallas(!modalArchivoTallas);
  const [conteoIgnoradosTallas, setConteoIgnoradosTallas] = useState({
  sinNombre: 0,
  sinArea: 0,
  sinDepartamento: 0,
});
const [colaboradoresImportar, setColaboradoresImportar] = useState([]);

  const [activo, setActivo] = useState("");
  const [contacto, setContacto] = useState("");
  const [grupo, setGrupo] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalBoni, setModalBoni] = useState(false);
  const toggleBoni = () => setModalBoni(!modalBoni);
  const [conceptosBonificaciones, setConceptosBonificaciones] = useState([]);
  const [boniCliente, setBoniCliente] = useState([]);
  const [idClienteBoni, setIdClienteBoni] = useState("");
  const [clienteBoniName, setClienteBoniName] = useState("");

  const [modalAreas, setModalAreas] = useState(false);
  const toggleModalAreas = () => setModalAreas(!modalAreas);
    const [areas, setAreas] = useState([]);
  const [selectedClienteAreas, setSelectedClienteAreas] = useState("");
  const [name, setName] = useState("");
  const [idEdit, setIdEdit] = useState();

  // Direcciones Sucursal
  const [sucursales, setSucursales] = useState([]);
  const [sucursalesClientes, setSucursalesClientes] = useState([]);
  const [idClienteSucursal, setIdClienteSucursal] = useState("");
  const [modalSucursal, setModalSucursal] = useState(false);
  const toggleSucursal = () => setModalSucursal(!modalSucursal);

  const [abrirSucursal, setAbrirSucursal] = useState(false);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      fecha: "",
      concepto: "",
      fijo: "",
      porcentaje: 0,
      importe: 0,
      observaciones: "NA",
    },
  ]);

  const [inputFieldsCuentas, setInputFieldsCuentas] = useState([
    {
      id: uuidv4(),
      banco: "",
      cuenta: "",
      rfc: "",
    },
  ]);

  const [inputFieldsColaboradores, setInputFieldsColaboradores] = useState([
    {
      id: uuidv4(),
      numero: "",
      nombre: "",
      estado: "NA",
      selectedSucursal: "",
      selectedArea: "",
      telefono: "",
      selectedDepartamento: "",
    },
  ]);
  const filter = createFilterOptions();

const [modalNuevaTalla, setModalNuevaTalla] = useState(false);
const [nuevaTallaNombre, setNuevaTallaNombre] = useState("");
const [savingTalla, setSavingTalla] = useState(false);

const [variantesTallas, setVariantesTallas] = useState([]);
const [variante, setVariante] = useState("");

// para saber a qué subgrupo asignar la talla nueva
const [targetSubGrupoTalla, setTargetSubGrupoTalla] = useState(null); 
// { parentId: a.id, index }

  const [inputFieldsSuc, setInputFieldsSuc] = useState([
    {
      id: uuidv4(),
      alias: "",
      responsable: "",
      calle: "",
      numero_ext: "",
      numero_int: "",
      delegacion: "",
      estado: "",
      pais: "",
      cp: "",
      colonia: "",
      ciudad: "",
      RFC: "",
      razon_social: "",
      regFiscal: "",
    },
  ]);

    const [inputFieldsSucArchivo, setInputFieldsSucArchivo] = useState([
    {
      id: uuidv4(),
      alias: "",
      responsable: "",
      calle: "",
      numero_ext: "",
      numero_int: "",
      delegacion: "",
      estado: "",
      pais: "",
      cp: "",
      colonia: "",
      ciudad: "",
      RFC: "",
      razon_social: "",
      regFiscal: "",
    },
  ]);
const [modalSucursalesOpen, setModalSucursalesOpen] = useState(false);
const toggleModalSucursales = () => setModalSucursalesOpen((v) => !v);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {

        if (user.tipo == "Cliente") {
      setSelectedCliente(user.clientes);
    }

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        // Array para pagination
        let arrayTabla = allClientes
          .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              activo: a.is_active,
              telefono: a.telefono,
              email: a.email,
              calle: a.calle,
              numero_ext: a.numero_ext,
              numero_int: a.numero_int,
              pais: a.pais,
              estado: a.estado,
              ciudad: a.ciudad,
              delegacion: a.delegacion,
              colonia: a.colonia,
              codigo: a.codigo,
              numero: a.numero,
              cp: a.cp,
              nombre_comercial: a.nombre_comercial,
              razon_social: a.razon_social,
              RFC: a.RFC,
              grupo: a.grupos[0].name,
              idGrupo: a.grupos[0]._id,
              contacto: a.contacto[0].nombre + " " + a.contacto[0].apellido,
              idContacto: a.contacto[0]._id,
              observaciones: a.observaciones,
              ultimo_pago: a.ultimo_pago,
              forma_pago: a.forma_pago,
              plazo: a.plazo,
              regFiscal: a.regFiscal,
              usoCFDI: a.usoCFDI,
              formaPagoSAT: a.formaPagoSAT,
              condicionesPagoSAT: a.condicionesPagoSAT,
              condicionesCotizacion: a.condicionesCotizacion,
              metodoPagoSAT: a.metodoPagoSAT,
              fiscal: a.fiscal,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setClientes(allClientes);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_GRUPOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allGrupos = response.data;
        setGrupos(allGrupos);
      })
      .catch((err) => {
        console.log(err);
      });

    // axios
    //   .get(URL_AREAS_CLIENTES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((response) => {
    //     let allAreasClientes = response.data;
    //     setAreasClientes(allAreasClientes);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CONCEPTOS_BONIFICACIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allConceptosBonificaciones = response.data;
        setConceptosBonificaciones(allConceptosBonificaciones);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_DEPARTAMENTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allDep = response.data;
        setDepartamentos(allDep);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_SUBDEPARTAMENTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSubDep = response.data;
        setSubDepartamentos(allSubDep);
        //
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allTallas = response.data;
        setTallas(allTallas);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user, selectedCliente]);

  const ListaClientes = clientes.sort((a, b) =>
    a.nombre_comercial > b.nombre_comercial ? 1 : -1
  );

  useEffect(() => {
  if (!idClienteCol) {
    setAreas([]);
    setAreasClientes([]);
    return;
  }

  axios
    .get(`${URL_AREAS_CLIENTES}/cliente/${idClienteCol}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      setAreas(response.data || []);
      setAreasClientes(response.data || []);
    })
    .catch((err) => {
      console.log(err);
      setAreas([]);
      setAreasClientes([]);
    });
}, [idClienteCol]);

  function PDFTabla() {
    const data = ListaClientes.map((a) => {
      if (
        (grupo == 0 || grupo == a.grupos[0]._id) &&
        (contacto == 0 || contacto == a.contacto[0]._id) &&
        (activo == 0 || activo == a.is_active)
      ) {
        return [
          a.nombre_comercial,
          a.telefono,
          a.email,
          a.grupos[0].name,
          [a.contacto[0].nombre + " " + a.contacto[0].apellido],
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Clientes`, 20, 40);
    doc.autoTable({
      head: [["Nombre", "Telefono", "Mail", "Zona", "Contacto"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    doc.save(`Clientes.pdf`);
  }

  function excel() {
    const dataExcel = ListaClientes.map((a) => {
      if (
        (grupo == 0 || grupo == a.grupos[0]._id) &&
        (contacto == 0 || contacto == a.contacto[0]._id) &&
        (activo == 0 || activo == a.is_active)
      ) {
        return {
          Nombre: a.nombre_comercial,
          Telefono: a.telefono,
          Mail: a.email,
          Zona: a.grupos[0].name,
          Contacto: [a.contacto[0].nombre + " " + a.contacto[0].apellido],
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoClientes";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoClientes",
        sheetFilter: ["Nombre", "Telefono", "Mail", "Zona", "Contacto"],
        sheetHeader: ["Nombre", "Telefono", "Mail", "Zona", "Contacto"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = ListaClientes.map((a) => {
      if (
        (grupo == 0 || grupo == a.grupos[0]._id) &&
        (contacto == 0 || contacto == a.contacto[0]._id) &&
        (activo == 0 || activo == a.is_active)
      ) {
        return [
          a.nombre_comercial,
          a.telefono,
          a.email,
          a.grupos[0].name,
          [a.contacto[0].nombre + " " + a.contacto[0].apellido],
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Clientes`, 20, 40);
    doc.autoTable({
      head: [["Nombre", "Telefono", "Mail", "Zona", "Contacto"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = doc.output("datauristring").split(",")[1];

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Clientes",
          email: mailTo,
          fileName: "ListadoClientes.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Clientes.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    idEdit,
    telefono,
    email,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    nombre_comercial,
    razon_social,
    RFC,
    gruposName,
    gruposId,
    contactoNombre,
    contactoId,
    observaciones,
    ultimo_pago,
    forma_pago,
    usoCFDI,
    regFiscal,
    formaPagoSAT,
    condicionesPagoSAT,
    metodoPagoSAT,
    codigo,
    numero,
    plazo,
    condicionesCotizacion
  ) {
    setTelefono(telefono);
    setEmail(email);
    setEmailViejo(email);
    setCalle(calle);
    setNumeroExt(numero_ext);
    setNumeroInt(numero_int);
    setPais(pais);
    setEstado(estado);
    setCiudad(ciudad);
    setDelegacion(delegacion);
    setColonia(colonia);
    setCP(cp);
    setNombreComercial(nombre_comercial);
    setRazonSocial(razon_social);
    setRFC(RFC);
    setSelectedGrupoName(gruposName);
    setSelectedGrupoEdit(gruposId);
    setSelectedContactoName(contactoNombre);
    setSelectedContacto(contactoId);
    setObservaciones(observaciones);
    setUltimoPago(ultimo_pago);
    setFormaPago(forma_pago);
    setusoCFDI(usoCFDI);
    setRegFiscal(regFiscal);
    setFormaPagoSAT(formaPagoSAT);
    setCondicionesPagoSAT(condicionesPagoSAT);
    setMetodoPagoSAT(metodoPagoSAT);
    setCodigo(codigo);
    setNumero(numero);
    setIdEditCliente(idEdit);
    setPlazo(plazo);
    setCondicionesCotizacion(condicionesCotizacion);
    toggleEdit();
  }

  function Info(id) {
    setIdInfo(id);
    toggle();
  }

  function editClientes(event) {
    event.preventDefault();
    const URL_CLIENTES_EDIT = `${process.env.REACT_APP_URL_CLIENTES}/${idEditCliente}`;

    axios
      .patch(
        URL_CLIENTES_EDIT,
        {
          nombre_comercial,
          razon_social,
          RFC,
          calle,
          numero_ext,
          numero_int,
          delegacion,
          estado,
          pais,
          cp,
          colonia,
          ciudad,
          telefono,
          email,
          grupos: selectedGrupoEdit,
          contacto: selectedContacto,
          observaciones,
          ultimo_pago,
          forma_pago,
          usoCFDI,
          regFiscal,
          formaPagoSAT,
          condicionesPagoSAT,
          metodoPagoSAT,
          codigo,
          plazo,
          condicionesCotizacion
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Cliente",
            detalle: `${nombre_comercial}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Nombre Comercial", field: "nombre_comercial", sortable: true },
    { name: "Telefono", field: "telefono", sortable: false },
    { name: "Email", field: "email", sortable: true },
    { name: "Zona", field: "grupo", sortable: true },
    { name: "Contacto", field: "contacto", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.nombre_comercial.toLowerCase().includes(search.toLowerCase()) ||
          comment.email.toLowerCase().includes(search.toLowerCase()) ||
          comment.grupo.toLowerCase().includes(search.toLowerCase()) ||
          comment.contacto.toLowerCase().includes(search.toLowerCase())||
          comment.numero.toString().includes(search)
      );
    }
    if (grupo) {
      computedComments = computedComments.filter((e) =>
        e.idGrupo.includes(grupo)
      );
    }
    if (contacto) {
      computedComments = computedComments.filter((e) =>
        e.idContacto.includes(contacto)
      );
    }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }

     if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e._id.includes(selectedCliente)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

   //Sorting comments
     if (
      sorting.field &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }
        //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );

  }, [comments, currentPage, search, sorting, contacto, grupo, activo]);

  function jalaBoni(id, name) {
    setIdClienteBoni(id);
    setClienteBoniName(name);

    axios
      .get(`${URL_BONIFICACIONES_RECURRENTES}Cliente/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBoniCliente = response.data;
        let arrayTabla = allBoniCliente
          .map((a) => {
            return {
              id: a._id,
              fecha: a.fecha,
              concepto: a.conceptosBonificaciones[0]._id,
              fijo: a.fijo,
              porcentaje: a.porcentaje,
              importe: a.importe,
              observaciones: a.observaciones,
              is_active: a.is_active,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setBoniCliente(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

    toggleBoni();
  }

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleChangeInputExistentes = (id, event) => {
    const newBoniCliente = boniCliente.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setBoniCliente(newBoniCliente);
  };

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        fecha: "",
        concepto: "",
        fijo: "",
        porcentaje: 0,
        importe: 0,
        observaciones: "NA",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
  };

  function saveBoni() {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se registrará la bonificacion",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then((result) => {
      if (result.isConfirmed) {
        toggleProgreso();
        let totalMails = inputFields.length + boniCliente.length;

        inputFields.map((a) => {
          if (a.porcentaje > 0 || a.importe > 0) {
            axios
              .post(
                URL_BONIFICACIONES_RECURRENTES,
                {
                  fecha: a.fecha,
                  importe: a.importe,
                  porcentaje: a.porcentaje,
                  clientes: idClienteBoni,
                  conceptosBonificaciones: a.concepto,
                  observaciones: a.observaciones,
                  fijo: a.fijo,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((data) => {
                totalMails = totalMails - 1;
                if (totalMails == 0) {
                  Swal.fire("Good job!", "Creado con exito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  // footer: `${error.response.data}`,
                });
                console.log(error);
              });
          } else {
            totalMails = totalMails - 1;
          }
        });

        boniCliente.map((a) => {
          axios
            .patch(
              `${URL_BONIFICACIONES_RECURRENTES}/${a.id}`,
              {
                fecha: a.fecha,
                importe: a.importe,
                porcentaje: a.porcentaje,
                conceptosBonificaciones: a.concepto,
                observaciones: a.observaciones,
                fijo: a.fijo,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then((data) => {
              totalMails = totalMails - 1;
              if (totalMails == 0) {
                Swal.fire("Good job!", "Creado con exito", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                // footer: `${error.response.data}`,
              });
              console.log(error);
            });
        });
      }
    });
  }

  function altaBoni(id) {
    axios
      .patch(
        `${URL_BONIFICACIONES_RECURRENTES}/${id}`,
        {
          is_active: "Si",
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((data) => {
        Swal.fire("Good job!", "Creado con exito", "success");

        const newBoniCliente = boniCliente.map((i) => {
          if (id === i.id) {
            i.is_active = "Si";
          }
          return i;
        });
        setBoniCliente(newBoniCliente);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          // footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function bajaBoni(id) {
    axios
      .patch(
        `${URL_BONIFICACIONES_RECURRENTES}/${id}`,
        {
          is_active: "No",
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((data) => {
        Swal.fire("Good job!", "Creado con exito", "success");
        const newBoniCliente = boniCliente.map((i) => {
          if (id === i.id) {
            i.is_active = "No";
          }
          return i;
        });
        setBoniCliente(newBoniCliente);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          // footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function cue(id, nombre_comercial) {
    setIdClienteCuenta(id);
    setNombreComercial(nombre_comercial);
    axios
      .get(`${URL_CUENTAS_CLIENTES}/cliente/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCuentas = res.data;
        setCuentas(allCuentas);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleCuenta();
  }

  const handleChangeInputCuentasExistentes = (id, event) => {
    const newCuentas = cuentas.map((i) => {
      if (id === i._id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setCuentas(newCuentas);
  };

  const handleChangeInputCuentas = (id, event) => {
    const newInputFieldsCuentas = inputFieldsCuentas.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsCuentas(newInputFieldsCuentas);
  };

  function saveCuenta() {
    let totalCuen = cuentas.length + inputFieldsCuentas.length;
    cuentas.map((a) => {
      if (a.cuenta != "") {
        axios
          .patch(
            `${URL_CUENTAS_CLIENTES}/${a._id}`,
            {
              cuenta: a.cuenta,
              banco: a.banco,
              rfc: a.rfc,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            totalCuen = totalCuen - 1;
            if (totalCuen == 0) {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Editar Cuentas Clientes",
                  detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire("Good job!", "Creado con exito", `success`);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      } else {
        totalCuen = totalCuen - 1;
        if (totalCuen == 0) {
          axios.post(
            URL_LOGS,
            {
              tipo: "Editar Cuenta Clientes",
              detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          Swal.fire("Good job!", "Creado con exito", `success`);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      }
    });

    // agregar inputFields
    inputFieldsCuentas.map((a) => {
      if (a.cuenta != "") {
        axios
          .post(
            `${URL_CUENTAS_CLIENTES}`,
            {
              clientes: idClienteCuenta,
              cuenta: a.cuenta,
              banco: a.banco,
              rfc: a.rfc,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            totalCuen = totalCuen - 1;
            if (totalCuen == 0) {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Editar Cuenta Clientes",
                  detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire("Good job!", "Creado con exito", `success`);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      } else {
        totalCuen = totalCuen - 1;
        if (totalCuen == 0) {
          axios.post(
            URL_LOGS,
            {
              tipo: "Editar Cuenta Clientes",
              detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          Swal.fire("Good job!", "Creado con exito", `success`);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      }
    });
  }

  const handleAddFieldsCuentas = () => {
    setInputFieldsCuentas([
      ...inputFieldsCuentas,
      {
        id: uuidv4(),
        banco: "",
        cuenta: "",
        rfc: "",
      },
    ]);
  };

  const handleRemoveFieldsCuentas = (id) => {
    const values = [...inputFieldsCuentas];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsCuentas(values);
  };

  function altaCuenta(id) {
    axios
      .patch(
        `${URL_CUENTAS_CLIENTES}/${id}`,
        {
          is_active: "Si",
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((data) => {
        Swal.fire("Good job!", "Creado con exito", "success");

        const newCuentas = cuentas.map((i) => {
          if (id === i._id) {
            i.is_active = "Si";
          }
          return i;
        });
        setCuentas(newCuentas);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          // footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function bajaCuenta(id) {
    axios
      .patch(
        `${URL_CUENTAS_CLIENTES}/${id}`,
        {
          is_active: "No",
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((data) => {
        Swal.fire("Good job!", "Creado con exito", "success");
        const newCuentas = cuentas.map((i) => {
          if (id === i._id) {
            i.is_active = "No";
          }
          return i;
        });
        setCuentas(newCuentas);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          // footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function altaFiscal(id) {
    axios
      .patch(
        `${URL_CLIENTES}/${id}`,
        {
          fiscal: "Si",
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((data) => {
        Swal.fire("Good job!", "Creado con exito", "success");

        const newComments = comments.map((i) => {
          if (id === i._id) {
            i.fiscal = "Si";
          }
          return i;
        });
        setComments(newComments);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          // footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function bajaFiscal(id) {
    axios
      .patch(
        `${URL_CLIENTES}/${id}`,
        {
          fiscal: "No",
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((data) => {
        Swal.fire("Good job!", "Creado con exito", "success");
        const newComments = comments.map((i) => {
          if (id === i._id) {
            i.fiscal = "No";
          }
          return i;
        });
        setComments(newComments);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          // footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function dir(id, nombre_comercial) {
    setIdClienteSucursal(id);
    setNombreComercial(nombre_comercial);
    axios
      .get(`${URL_SUCURSALES}/clientes/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allSucursales = res.data;
        setSucursales(allSucursales);
      })
      .catch((err) => {
        console.log(err);
      });
    setAbrirSucursal(true);
  }

  const handleChangeInputExistentesSuc = (id, event) => {
    const newSucursales = sucursales.map((i) => {
      if (id === i._id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setSucursales(newSucursales);
  };

  const handleChangeInputSuc = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsSuc(newInputFields);
  };

  function saveDireccion() {
    let totalDir = sucursales.length + inputFieldsSuc.length;
    sucursales.map((a) => {
      if (a.alias != "") {
        axios
          .patch(
            `${URL_SUCURSALES}/${a._id}`,
            {
              alias: a.alias,
              responsable: a.responsable,
              calle: a.calle,
              numero_ext: a.numero_ext,
              numero_int: a.numero_int,
              delegacion: a.delegacion,
              estado: a.estado,
              pais: a.pais,
              cp: a.cp,
              colonia: a.colonia,
              ciudad: a.ciudad,
              RFC: a.RFC,
              razon_social: a.razon_social,
              regFiscal: a.regFiscal,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            totalDir = totalDir - 1;
            if (totalDir == 0) {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Editar Sucursal",
                  detalle: `Cliente ${idClienteSucursal} / Alias ${a.alias}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire("Good job!", "Creado con exito", `success`);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      } else {
        totalDir = totalDir - 1;
      }
    });

    // agregar inputFields
    inputFieldsSuc.map((a) => {
      if (a.alias != "") {
        axios
          .post(
            `${URL_SUCURSALES}`,
            {
              alias: a.alias,
              responsable: a.responsable,
              calle: a.calle,
              numero_ext: a.numero_ext,
              numero_int: a.numero_int,
              delegacion: a.delegacion,
              estado: a.estado,
              pais: a.pais,
              cp: a.cp,
              colonia: a.colonia,
              ciudad: a.ciudad,
              clientes: idClienteSucursal,
              RFC: a.RFC,
              razon_social: a.razon_social,
              regFiscal: a.regFiscal,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            totalDir = totalDir - 1;
            if (totalDir == 0) {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Editar Sucursal",
                  detalle: `Cliente ${idClienteSucursal} / Alias ${a.alias}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire("Good job!", "Creado con exito", `success`);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      } else {
        totalDir = totalDir - 1;
      }
    });
  }

  const handleAddFieldsSuc = () => {
    setInputFieldsSuc([
      ...inputFields,
      {
        id: uuidv4(),
        alias: "",
        responsable: "",
        calle: "",
        numero_ext: "",
        numero_int: "",
        delegacion: "",
        estado: "",
        pais: "",
        cp: "",
        colonia: "",
        ciudad: "",
        RFC: "",
        razon_social: "",
        regFiscal: "",
      },
    ]);
  };

  async function jalaColaboradores(idClienteCol, nombre_comercial) {
    setIdClienteCol(idClienteCol);
    setNombreComercial(nombre_comercial);
    setSucursales([])
    try {
      axios
        .get(`${URL_SUCURSALES}/clientes/${idClienteCol}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allSucursales = res.data;
          setSucursales(allSucursales);
        })
        .catch((err) => {
          console.log(err);
        });

      // 1. Obtener colaboradores del cliente
      const resColaboradores = await axios.get(
        `${URL_COLABORADORES_CLIENTES}/cliente/${idClienteCol}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

const colaboradores = resColaboradores.data.map((col) => {
  const sucursalId =
    typeof col.sucursales?.[0] === "object"
      ? col.sucursales[0]?._id
      : col.sucursales?.[0] || "";

  const departamentoId =
    typeof col.departamentos?.[0] === "object"
      ? col.departamentos[0]?._id
      : col.departamentos?.[0] || "";

  const areaId =
    typeof col.areasClientes?.[0] === "object"
      ? col.areasClientes[0]?._id
      : col.areasClientes?.[0] || "";

  return {
    ...col,
    sucursal: sucursalId, // ← agrega esto
    selectedSucursal: sucursalId, // ← este es para el input
    selectedDepartamento: departamentoId,
    selectedArea: areaId,
  };
});


      setColaboradoresCliente(colaboradores);

      // 2. Obtener tallas asociadas a colaboradores
      const resTallas = await axios.get(
        `${URL_COLABORADORES_TALLAS}/cliente/${idClienteCol}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      const agrupado = {};

      resTallas.data.forEach((registro) => {
        const colaboradorId =
          typeof registro.colaboradoresClientes === "object"
            ? registro.colaboradoresClientes?._id
            : registro.colaboradoresClientes;

        if (!colaboradorId) {
          console.warn("❌ Registro sin colaborador:", registro);
          return; // Ignorar si no tiene colaborador
        }

        if (!agrupado[colaboradorId]) agrupado[colaboradorId] = [];

        agrupado[colaboradorId].push({
          _id: registro._id,
          is_active: registro.is_active,
          observaciones: registro.observaciones,
          subDepartamento:
            typeof registro.subDepartamentos?.[0] === "object"
              ? registro.subDepartamentos[0]?._id
              : registro.subDepartamentos?.[0] || "",

          talla:
            typeof registro.tallas?.[0] === "object"
              ? registro.tallas[0]?._id
              : registro.tallas?.[0] || "",
        });
      });

      setColaboradoresTallasExistentes(agrupado);
    } catch (error) {
      console.error("Error cargando colaboradores y tallas:", error);
      Swal.fire("Error", "No se pudo cargar la información", "error");
    }

    toggleColaboradores();
  }

  const handleChangeInputColaboradoresExistentes = (id, event) => {
    const { name, value } = event.target;

    const nuevos = colaboradoresCliente.map((i) => {
      if (i._id === id) {
        if (name === "selectedDepartamento") {
          return { ...i, selectedDepartamento: value };
        } else if (name === "selectedArea") {
          return { ...i, selectedArea: value };
        } else if (name === "sucursales") {
          return { ...i, selectedSucursal: value }; // guarda el ID
        } else {
          return { ...i, [name]: value };
        }
      }
      return i;
    });

    setColaboradoresCliente(nuevos);
  };

const handleChangeInputColaboradores = (id, event) => {
  const { name, value } = event.target;

  const nuevos = inputFieldsColaboradores.map((i) => {
    if (i.id === id) {
      if (name === "selectedDepartamento") {
        return { ...i, selectedDepartamento: value };
      } else if (name === "selectedArea") {
        return { ...i, selectedArea: value };
      } else if (name === "selectedSucursal") { // <== ESTE NOMBRE ES CLAVE
        return { ...i, selectedSucursal: value };
      } else {
        return { ...i, [name]: value };
      }
    }
    return i;
  });

  setInputFieldsColaboradores(nuevos);
};


  const handleAddFieldsColaboradores = (limpiarId = null) => {
  const nuevoId = uuidv4();

  setInputFieldsColaboradores((prev) => {
    const actualizados = limpiarId
      ? prev.filter((c) => c.id !== limpiarId) // ❌ elimina al anterior si aplica
      : prev;

    return [
      ...actualizados,
      {
        id: nuevoId,
        numero: "",
        nombre: "",
        estado: "NA",
        selectedSucursal: "",
        selectedArea: "",
        telefono: "",
        selectedDepartamento: "0",
      },
    ];
  });

  setColaboradoresTallasNuevos((prev) => {
    const actualizados = { ...prev };
    if (limpiarId) delete actualizados[limpiarId]; // ❌ elimina tallas previas
    actualizados[nuevoId] = []; // ✅ inicializa nuevas
    return actualizados;
  });
};


  const handleRemoveFieldsColaboradores = (id) => {
    const values = [...inputFieldsColaboradores];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsColaboradores(values);
  };

async function saveColaboradores() {
  let totalCuen = colaboradoresCliente.length;

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const guardarTallaExistente = async (
    colaboradorId,
    grupo,
    selectedDepartamento
  ) => {
    if (!grupo.subDepartamento || !grupo.talla) return;

    const payload = {
      colaboradoresClientes: colaboradorId,
      clientes: idClienteCol,
      departamentos: [selectedDepartamento],
      subDepartamentos: [grupo.subDepartamento],
      tallas: [grupo.talla],
      observaciones: grupo.observaciones,
    };

    try {
      if (grupo._id) {
        // Actualiza talla existente
        await axios.patch(`${URL_COLABORADORES_TALLAS}/${grupo._id}`, payload, {
          headers,
        });
      } else {
        // Crea nueva talla
        await axios.post(`${URL_COLABORADORES_TALLAS}`, payload, {
          headers,
        });
      }
    } catch (err) {
      console.error("Error guardando talla:", err);
    }
  };

  // ✅ Solo actualizar colaboradores existentes
  for (const a of colaboradoresCliente) {
    try {
      const body = {
        numero: a.numero,
        nombre: a.nombre,
        estado: a.estado,
        departamentos: a.selectedDepartamento,
        areasClientes: a.selectedArea,
        telefono: a.telefono,
      };

      if (a.selectedSucursal && a.selectedSucursal !== "0") {
        body.sucursales = [a.selectedSucursal];
      }

      await axios.patch(`${URL_COLABORADORES_CLIENTES}/${a._id}`, body, {
        headers,
      });

      const grupos = colaboradoresTallasExistentes[a._id] || [];
      for (const grupo of grupos) {
        await guardarTallaExistente(a._id, grupo, a.selectedDepartamento);
      }

      totalCuen--;
    } catch (error) {
      Swal.fire("Error", `Error actualizando ${a.nombre}`, "error");
      console.error(error);
    }
  }

  // ✅ Finalizar
  if (totalCuen === 0) {
    try {
      await axios.post(
        `${URL_LOGS}`,
        {
          tipo: "Editar Colaboradores Clientes",
          detalle: `Cliente ${idClienteCol}`,
          user: user.id,
        },
        { headers }
      );

      Swal.fire("Good job!", "Guardado con éxito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error guardando log:", error);
    }
  }
}



  async function altaColaborador(id) {
  try {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    // 1. Desactivar colaborador
    await axios.patch(`${URL_COLABORADORES_CLIENTES}/${id}`, {
      is_active: "Si",
    }, { headers });

    // 2. Desactivar tallas relacionadas
    await axios.patch(`${URL_COLABORADORES_TALLAS}Colaborador/${id}`, {is_active: "Si"}, { headers });

    // 3. Feedback al usuario
    Swal.fire("Good job!", "Colaborador desactivado con éxito", "success");

    // 4. Actualizar estado local
    const newCuentas = colaboradoresCliente.map((i) => {
      if (id === i._id) {
        i.is_active = "Si";
      }
      return i;
    });
    setColaboradoresCliente(newCuentas);
  } catch (error) {
    console.error("Error desactivando colaborador y tallas:", error);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Error al desactivar",
    });
  }
}

 async function bajaColaborador(id) {
  try {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    // 1. Desactivar colaborador
    await axios.patch(`${URL_COLABORADORES_CLIENTES}/${id}`, {
      is_active: "No",
    }, { headers });

    // 2. Desactivar tallas relacionadas
    await axios.patch(`${URL_COLABORADORES_TALLAS}Colaborador/${id}`, {is_active: "No"}, { headers });

    // 3. Feedback al usuario
    Swal.fire("Good job!", "Colaborador desactivado con éxito", "success");

    // 4. Actualizar estado local
    const newCuentas = colaboradoresCliente.map((i) => {
      if (id === i._id) {
        i.is_active = "No";
      }
      return i;
    });
    setColaboradoresCliente(newCuentas);
  } catch (error) {
    console.error("Error desactivando colaborador y tallas:", error);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Error al desactivar",
    });
  }
}

  // const [mostrarTallas, setMostrarTallas] = useState({});

  // const toggleMostrarTallas = (id) => {
  //   setMostrarTallas((prev) => ({ ...prev, [id]: !prev[id] }));
  // };

  // const handleSeleccionTallas = (id, tallasSeleccionadas) => {
  //   setColaboradoresTallasNuevos((prev) => ({
  //     ...prev,
  //     [id]: {
  //       ...prev[id],
  //       tallas: tallasSeleccionadas,
  //     },
  //   }));
  // };

  // const handleSeleccionSubDepartamentos = (id, seleccionados) => {
  //   setColaboradoresTallasNuevos((prev) => ({
  //     ...prev,
  //     [id]: {
  //       ...prev[id],
  //       subDepartamentos: seleccionados,
  //     },
  //   }));
  // };

  const agregarSubGrupo = (id) => {
    setColaboradoresTallasNuevos((prev) => ({
      ...prev,
      [id]: [...(prev[id] || []), { subDepartamento: "", talla: "" }],
    }));
  };

  const eliminarSubGrupo = (id, index) => {
    setColaboradoresTallasNuevos((prev) => {
      const nuevos = [...(prev[id] || [])];
      nuevos.splice(index, 1);
      return { ...prev, [id]: nuevos };
    });
  };

  const toggleSubTallas = (id) => {
    setMostrarSubTallas((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const actualizarSubGrupo = (id, index, campo, valor) => {
    setColaboradoresTallasNuevos((prev) => {
      const nuevos = [...(prev[id] || [])];
      nuevos[index][campo] = valor;
      return { ...prev, [id]: nuevos };
    });
  };

const toggleSubTallasEdit = async (colaboradorId) => {
  // Si ya están cargadas, solo mostrar u ocultar
  if (colaboradoresTallasExistentes[colaboradorId]) {
    setMostrarSubTallasEdit((prev) => ({
      ...prev,
      [colaboradorId]: !prev[colaboradorId],
    }));
    return;
  }

  // Si no están cargadas, pedirlas
  try {
    const res = await axios.get(`${URL_COLABORADORES_TALLAS}/colaborador/${colaboradorId}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    });

    const tallas = res.data
    .filter((t) => t.is_active === "Si")
    .map((t) => ({
      _id: t._id,
      subDepartamento: t.subDepartamentos?.[0]?._id || "",
      talla: t.tallas?.[0] || "",
      is_active: t.is_active,
      observaciones: t.observaciones
    }));

    setColaboradoresTallasExistentes((prev) => ({
      ...prev,
      [colaboradorId]: tallas,
    }));

    // ✅ Ahora sí mostrar el bloque
    setMostrarSubTallasEdit((prev) => ({
      ...prev,
      [colaboradorId]: true,
    }));
  } catch (err) {
    console.error("Error cargando tallas del colaborador:", err);
    Swal.fire("Error", "No se pudieron cargar las tallas", "error");
  }
};



  const actualizarSubGrupoEdit = (id, index, campo, valor) => {
    setColaboradoresTallasExistentes((prev) => {
      const nuevos = [...(prev[id] || [])];
      nuevos[index][campo] = valor;
      return { ...prev, [id]: nuevos };
    });
  };

  // const eliminarSubGrupoEdit = (id, index) => {
  //   setColaboradoresTallasExistentes((prev) => {
  //     const nuevos = [...(prev[id] || [])];
  //     nuevos.splice(index, 1);
  //     return { ...prev, [id]: nuevos };
  //   });
  // };
  const eliminarSubGrupoEdit = async (colaboradorId, index) => {
  const grupo = colaboradoresTallasExistentes[colaboradorId][index];

  if (!grupo || !grupo._id) {
    console.warn("❌ No hay ID de grupo para eliminar");
    return;
  }

  try {
    await axios.patch(
      `${URL_COLABORADORES_TALLAS}/${grupo._id}`,
      { is_active: "No" },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    // Opcional: quitarlo del estado para que desaparezca visualmente
    setColaboradoresTallasExistentes((prev) => {
      const nuevos = { ...prev };
      nuevos[colaboradorId] = nuevos[colaboradorId].filter(
        (_, i) => i !== index
      );
      return nuevos;
    });
  } catch (error) {
    console.error("❌ Error eliminando talla:", error);
    Swal.fire("Error", "No se pudo eliminar la talla", "error");
  }
};


  const agregarSubGrupoEdit = (id) => {
    setColaboradoresTallasExistentes((prev) => ({
      ...prev,
      [id]: [...(prev[id] || []), { subDepartamento: "", talla: "" }],
    }));
  };

const guardarNuevoColaboradorConTallas = async (idTemp) => {
  const colaborador = inputFieldsColaboradores.find((c) => c.id === idTemp);
  const grupos = colaboradoresTallasNuevos[idTemp] || [];

  if (
    !colaborador ||
    !colaborador.nombre ||
    !colaborador.numero ||
    !colaborador.telefono ||
    !colaborador.selectedSucursal ||
    !colaborador.selectedDepartamento ||
    !colaborador.selectedArea
  ) {
    Swal.fire("Error", "El colaborador debe tener todos los datos", "error");
    return;
  }

  const confirm = await Swal.fire({
    title: "¿Ya cargaste todas las tallas?",
    text: "Una vez guardado, no podrás editarlas desde aquí.",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sí, guardar",
    cancelButtonText: "Cancelar",
  });

  if (!confirm.isConfirmed) return;

  try {
    // 1. Crear colaborador en la BD (con sucursales como array)
    const res = await axios.post(
      `${URL_COLABORADORES_CLIENTES}`,
      {
        clientes: idClienteCol,
        numero: colaborador.numero,
        nombre: colaborador.nombre,
        estado: colaborador.estado,
        sucursales: [colaborador.selectedSucursal], // ✅ CORRECTO
        departamentos: colaborador.selectedDepartamento,
        areasClientes: colaborador.selectedArea,
        telefono: colaborador.telefono,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const nuevoColaborador = res.data;

    // 2. Guardar tallas asociadas
    for (const grupo of grupos) {
      if (grupo.subDepartamento && grupo.talla) {
        await axios.post(
          `${URL_COLABORADORES_TALLAS}`,
          {
            colaboradoresClientes: nuevoColaborador._id,
            clientes: idClienteCol,
            departamentos: [colaborador.selectedDepartamento],
            subDepartamentos: [grupo.subDepartamento],
            tallas: [grupo.talla],
            observaciones: grupo.observaciones,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
      }
    }

    // 3. Eliminar de nuevos
    setInputFieldsColaboradores((prev) =>
      prev.filter((c) => c.id !== idTemp)
    );

    // 4. Agregar a existentes
    setColaboradoresCliente((prev) => [
      ...prev,
      {
        ...nuevoColaborador,
        selectedDepartamento: colaborador.selectedDepartamento,
        selectedArea: colaborador.selectedArea,
        selectedSucursal: colaborador.selectedSucursal, // ✅ mantener el valor
      },
    ]);

    // 5. Agregar un nuevo renglón vacío para capturar otro
    handleAddFieldsColaboradores();

    Swal.fire("Éxito", "Colaborador y tallas guardados", "success");
  } catch (error) {
    console.error("Error guardando colaborador o tallas:", error);
    Swal.fire("Error", "Ocurrió un error al guardar", "error");
  }
};

async function PDFTallasPorSucursal() {
  const doc = new jsPDF("landscape");

  const logo1 = new Image();
  logo1.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
  const logo2 = new Image();
  logo2.src = process.env.PUBLIC_URL + "logoInstitucion.png";

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  // Helpers
  const safeTrim = (v) => String(v || "").trim();

  const getLineaNombre = (g) =>
    safeTrim(g?.subDepartamentos?.[0]?.name) || "Desconocida";

  const getTallaNombre = (g) =>
    safeTrim(g?.tallas?.[0]?.name) || "Desconocida";

  const getVarianteNombre = (g) => {
    // Opción 1: talla.variantesTallas[0].name
    const v1 = g?.tallas?.[0]?.variantesTallas?.[0]?.name;
    // Opción 2: g.variantesTallas[0].name
    const v2 = g?.variantesTallas?.[0]?.name;

    const v = safeTrim(v1 || v2);
    return v ? v : "Sin variante";
  };

  const getTallaConVariante = (g) => {
    const talla = getTallaNombre(g);
    const variante = getVarianteNombre(g);
    return variante && variante !== "Sin variante" ? `${talla} (${variante})` : talla;
  };

  const makeKeyVarianteTalla = (g) => {
    const talla = getTallaNombre(g);
    const variante = getVarianteNombre(g) || "Sin variante";
    return `${variante}||${talla}`;
  };

  const parseKeyVarianteTalla = (key) => {
    const [variante, talla] = String(key).split("||");
    return { variante, talla };
  };

  // 1. Obtener todas las tallas con populate
  let todasTallas = [];
  try {
    const res = await axios.get(
      `${URL_COLABORADORES_TALLAS}/cliente/${idClienteCol}`,
      { headers }
    );
    todasTallas = (res.data || []).filter((t) => t.is_active === "Si");
  } catch (err) {
    console.error("Error obteniendo tallas:", err);
    Swal.fire("Error", "No se pudieron obtener las tallas", "error");
    return;
  }

  // 2. Agrupar tallas por colaborador
  const tallasPorColaborador = {};
  todasTallas.forEach((t) => {
    const colId = t.colaboradoresClientes?.[0]?._id;
    if (!colId) return;
    if (!tallasPorColaborador[colId]) tallasPorColaborador[colId] = [];
    tallasPorColaborador[colId].push(t);
  });

  const sucursalesAgrupadas = {};
  const resumenPorSucursal = {}; // sucursal -> linea -> key(variante||talla) -> count

  // 3. Agrupar colaboradores por sucursal
  (colaboradoresCliente || []).forEach((col) => {
    const suc = col.selectedSucursal || "SIN_SUCURSAL";
    if (!sucursalesAgrupadas[suc]) {
      sucursalesAgrupadas[suc] = [];
      resumenPorSucursal[suc] = {};
    }
    sucursalesAgrupadas[suc].push(col);
  });

  const sucursalKeys = Object.keys(sucursalesAgrupadas);

  // 4. Páginas por sucursal (tabla colaboradores)
  sucursalKeys.forEach((idSucursal, index) => {
    if (index > 0) doc.addPage();

    const sucursal = (sucursales || []).find((s) => String(s._id) === String(idSucursal));
    const nombreSucursal = sucursal ? sucursal.alias : "Sin Sucursal";

    doc.addImage(logo1, "png", 230, 10, 45, 15);
    doc.addImage(logo2, "png", 120, 5, 60, 25);
    doc.setFontSize(14);
    doc.text(`Tallas por Colaborador`, 20, 25);
    doc.setFontSize(12);
    doc.text(`Sucursal: ${nombreSucursal}`, 20, 35);

    const rows = [];
    const colaboradores = sucursalesAgrupadas[idSucursal] || [];

    colaboradores.forEach((col) => {
      const grupos = tallasPorColaborador[col._id] || [];

      if (grupos.length === 0) {
        rows.push([
          col.numero || "",
          col.nombre || "",
          obtenerNombreDepartamento(col.selectedDepartamento),
          obtenerNombreArea(col.selectedArea),
          col.telefono || "",
          "Sin tallas",
          "",
        ]);
      } else {
        grupos.forEach((g) => {
          const lineaNombre = getLineaNombre(g);
          const tallaLabel = getTallaConVariante(g);

          rows.push([
            col.numero || "",
            col.nombre || "",
            obtenerNombreDepartamento(col.selectedDepartamento),
            obtenerNombreArea(col.selectedArea),
            col.telefono || "",
            lineaNombre,
            tallaLabel,
          ]);

          // resumen: sucursal -> linea -> (variante||talla) -> count
          if (!resumenPorSucursal[idSucursal][lineaNombre]) {
            resumenPorSucursal[idSucursal][lineaNombre] = {};
          }

          const keyVT = makeKeyVarianteTalla(g);
          if (!resumenPorSucursal[idSucursal][lineaNombre][keyVT]) {
            resumenPorSucursal[idSucursal][lineaNombre][keyVT] = 0;
          }
          resumenPorSucursal[idSucursal][lineaNombre][keyVT]++;
        });
      }
    });

    doc.autoTable({
      startY: 40,
      head: [["Número", "Colaborador", "Departamento", "Área", "Teléfono", "Línea", "Talla (Variante)"]],
      body: rows,
      styles: { fontSize: 9 },
    });
  });

  // 5. Resumen final (columna "Talla" = talla + variante)
  doc.addPage();
  doc.addImage(logo1, "png", 230, 10, 45, 15);
  doc.addImage(logo2, "png", 120, 5, 60, 25);
  doc.setFontSize(14);
  doc.text("Resumen General por Sucursal", 20, 25);

  let currentY = 35;

  sucursalKeys.forEach((idSucursal) => {
    const sucursal = (sucursales || []).find((s) => String(s._id) === String(idSucursal));
    const nombreSucursal = sucursal ? sucursal.alias : "Sin Sucursal";

    if (currentY > 180) {
      doc.addPage();
      doc.addImage(logo1, "png", 230, 10, 45, 15);
      doc.addImage(logo2, "png", 120, 5, 60, 25);
      doc.setFontSize(14);
      doc.text("Resumen General por Sucursal", 20, 25);
      currentY = 35;
    }

    doc.setFontSize(12);
    doc.text(`Sucursal: ${nombreSucursal}`, 20, currentY);
    currentY += 6;

    const resumenSucursal = resumenPorSucursal[idSucursal] || {};

    Object.entries(resumenSucursal)
      .sort(([a], [b]) => a.localeCompare(b)) // ordenar líneas
      .forEach(([linea, tallasObj]) => {
        if (currentY > 180) {
          doc.addPage();
          doc.addImage(logo1, "png", 230, 10, 45, 15);
          doc.addImage(logo2, "png", 120, 5, 60, 25);
          doc.setFontSize(14);
          doc.text("Resumen General por Sucursal", 20, 25);
          currentY = 35;
        }

        doc.setFontSize(11);
        doc.text(`Línea: ${linea}`, 25, currentY);
        currentY += 4;

        // ✅ AQUÍ: Talla = "talla (variante)" y ya no columna Variante
        const filas = Object.entries(tallasObj)
          .sort(([k1], [k2]) => k1.localeCompare(k2))
          .map(([keyVT, cantidad]) => {
            const { variante, talla } = parseKeyVarianteTalla(keyVT);
            const tallaLabel =
              variante && variante !== "Sin variante" ? `${talla} (${variante})` : talla;
            return [tallaLabel, cantidad];
          });

        doc.autoTable({
          startY: currentY,
          head: [["Talla", "Cantidad"]],
          body: filas,
          styles: { fontSize: 9 },
          theme: "striped",
          margin: { left: 25, right: 15 },
          didDrawPage: (data) => {
            currentY = data.cursor.y + 8;
          },
        });
      });

    currentY += 6;
  });

  doc.save("TallasPorSucursal.pdf");
}
// Helpers
function obtenerNombreDepartamento(id) {
  const dep = departamentos.find((d) => d._id === id);
  return dep ? dep.name : "";
}

function obtenerNombreArea(id) {
  const area = areasClientes.find((a) => a._id === id);
  return area ? area.name : "";
}


async function ExcelTallasPorSucursal() {
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  // Helpers
  const safeTrim = (v) => String(v || "").trim();

  const getTallaNombre = (g) =>
    safeTrim(g?.tallas?.[0]?.name) || "Desconocida";

  const getVarianteNombre = (g) => {
    const v1 = g?.tallas?.[0]?.variantesTallas?.[0]?.name; // anidado en talla
    const v2 = g?.variantesTallas?.[0]?.name; // directo en doc
    const v = safeTrim(v1 || v2);
    return v ? v : "Sin variante";
  };

  const getTallaConVariante = (g) => {
    const talla = getTallaNombre(g);
    const variante = getVarianteNombre(g);
    return variante && variante !== "Sin variante"
      ? `${talla} (${variante})`
      : talla;
  };

  const makeKeyVarianteTalla = (g) => {
    const talla = getTallaNombre(g);
    const variante = getVarianteNombre(g) || "Sin variante";
    return `${variante}||${talla}`;
  };

  const parseKeyVarianteTalla = (key) => {
    const [variante, talla] = String(key).split("||");
    return { variante, talla };
  };

  const getNombreSucursal = (idSucursal) => {
    if (String(idSucursal) === "SIN_SUCURSAL") return "Sin Sucursal";

    return (
      (sucursales || []).find((s) => String(s._id) === String(idSucursal))
        ?.alias || "Sin Sucursal"
    );
  };

  const getNombreDepartamento = (idDepartamento) => {
    return (
      (departamentos || []).find(
        (d) => String(d._id) === String(idDepartamento)
      )?.name || ""
    );
  };

  const getNombreArea = (idArea) => {
    return (
      (areasClientes || []).find((a) => String(a._id) === String(idArea))
        ?.name || ""
    );
  };

  let todasTallas = [];
  try {
    const res = await axios.get(
      `${URL_COLABORADORES_TALLAS}/cliente/${idClienteCol}`,
      { headers }
    );
    todasTallas = (res.data || []).filter((t) => t.is_active === "Si");
  } catch (err) {
    console.error("Error obteniendo tallas:", err);
    Swal.fire("Error", "No se pudieron obtener las tallas", "error");
    return;
  }

  // Agrupar tallas por colaborador
  const tallasPorColaborador = {};
  todasTallas.forEach((t) => {
    const colId = t.colaboradoresClientes?.[0]?._id;
    if (!colId) return;

    if (!tallasPorColaborador[colId]) {
      tallasPorColaborador[colId] = [];
    }

    tallasPorColaborador[colId].push(t);
  });

  const hojasExcel = [];
  const resumenPorSucursal = {}; 
  // sucursal -> linea -> key(variante||talla) -> count

  const resumenGeneral = {};
  // departamento||sucursal||area||linea||keyVT -> count

  // Agrupar colaboradores por sucursal
  const sucursalesAgrupadas = {};
  (colaboradoresCliente || []).forEach((col) => {
    const suc = col.selectedSucursal || "SIN_SUCURSAL";
    if (!sucursalesAgrupadas[suc]) sucursalesAgrupadas[suc] = [];
    sucursalesAgrupadas[suc].push(col);
  });

  // Ordenar sucursales alfabéticamente por alias
  const sucursalesOrdenadas = Object.keys(sucursalesAgrupadas).sort((a, b) => {
    const nombreA =
      getNombreSucursal(a) === "Sin Sucursal"
        ? "ZZZ_Sin Sucursal"
        : getNombreSucursal(a);
    const nombreB =
      getNombreSucursal(b) === "Sin Sucursal"
        ? "ZZZ_Sin Sucursal"
        : getNombreSucursal(b);

    return nombreA.localeCompare(nombreB, "es", { sensitivity: "base" });
  });

  sucursalesOrdenadas.forEach((idSucursal) => {
    const colaboradores = sucursalesAgrupadas[idSucursal] || [];
    const nombreSucursal = getNombreSucursal(idSucursal);

    const dataSucursal = [];

    colaboradores.forEach((col) => {
      const nombreDepartamento = getNombreDepartamento(col.selectedDepartamento);
      const nombreArea = getNombreArea(col.selectedArea);

      const grupos = tallasPorColaborador[col._id] || [];

      if (grupos.length === 0) {
        dataSucursal.push({
          Numero: col.numero || "",
          Colaborador: col.nombre || "",
          Departamento: nombreDepartamento,
          Sucursal: nombreSucursal,
          Area: nombreArea,
          Telefono: col.telefono || "",
          Linea: "Sin tallas",
          Talla: "",
        });
      } else {
        grupos.forEach((grupo) => {
          const linea =
            safeTrim(grupo?.subDepartamentos?.[0]?.name) || "Desconocida";

          const tallaLabel = getTallaConVariante(grupo);

          dataSucursal.push({
            Numero: col.numero || "",
            Colaborador: col.nombre || "",
            Departamento: nombreDepartamento,
            Sucursal: nombreSucursal,
            Area: nombreArea,
            Telefono: col.telefono || "",
            Linea: linea,
            Talla: tallaLabel,
          });

          // Resumen por sucursal
          if (!resumenPorSucursal[nombreSucursal]) {
            resumenPorSucursal[nombreSucursal] = {};
          }

          if (!resumenPorSucursal[nombreSucursal][linea]) {
            resumenPorSucursal[nombreSucursal][linea] = {};
          }

          const keyVT = makeKeyVarianteTalla(grupo);

          if (!resumenPorSucursal[nombreSucursal][linea][keyVT]) {
            resumenPorSucursal[nombreSucursal][linea][keyVT] = 0;
          }

          resumenPorSucursal[nombreSucursal][linea][keyVT]++;

          // Resumen general hoja 1
          const keyGeneral = [
            safeTrim(nombreDepartamento) || "Sin departamento",
            safeTrim(nombreSucursal) || "Sin sucursal",
            safeTrim(nombreArea) || "Sin area",
            safeTrim(linea) || "Sin linea",
            keyVT,
          ].join("|||");

          if (!resumenGeneral[keyGeneral]) {
            resumenGeneral[keyGeneral] = 0;
          }

          resumenGeneral[keyGeneral]++;
        });
      }
    });

    // Ordenar filas dentro de cada hoja
    dataSucursal.sort((a, b) => {
      const dep = String(a.Departamento || "").localeCompare(
        String(b.Departamento || ""),
        "es",
        { sensitivity: "base" }
      );
      if (dep !== 0) return dep;

      const colab = String(a.Colaborador || "").localeCompare(
        String(b.Colaborador || ""),
        "es",
        { sensitivity: "base" }
      );
      if (colab !== 0) return colab;

      const linea = String(a.Linea || "").localeCompare(
        String(b.Linea || ""),
        "es",
        { sensitivity: "base" }
      );
      if (linea !== 0) return linea;

      return String(a.Talla || "").localeCompare(String(b.Talla || ""), "es", {
        sensitivity: "base",
      });
    });

    hojasExcel.push({
      sheetData: dataSucursal,
      sheetName: nombreSucursal.slice(0, 30),
      sheetFilter: [
        "Numero",
        "Colaborador",
        "Departamento",
        "Sucursal",
        "Area",
        "Telefono",
        "Linea",
        "Talla",
      ],
      sheetHeader: [
        "Numero",
        "Colaborador",
        "Departamento",
        "Sucursal",
        "Area",
        "Telefono",
        "Linea",
        "Talla",
      ],
    });
  });

  // ===== Hoja 1: Resumen general =====
  const dataResumenGeneral = Object.entries(resumenGeneral)
    .map(([key, cantidad]) => {
      const [departamento, sucursal, area, linea, keyVT] = String(key).split(
        "|||"
      );

      const { variante, talla } = parseKeyVarianteTalla(keyVT);

      const tallaLabel =
        variante && variante !== "Sin variante"
          ? `${talla} (${variante})`
          : talla;

      return {
        Departamento: departamento,
        Sucursal: sucursal,
        Area: area,
        Linea: linea,
        Talla: tallaLabel,
        Cantidad: cantidad,
      };
    })
    .sort((a, b) => {
      const dep = String(a.Departamento || "").localeCompare(
        String(b.Departamento || ""),
        "es",
        { sensitivity: "base" }
      );
      if (dep !== 0) return dep;

      const suc = String(a.Sucursal || "").localeCompare(
        String(b.Sucursal || ""),
        "es",
        { sensitivity: "base" }
      );
      if (suc !== 0) return suc;

      const area = String(a.Area || "").localeCompare(
        String(b.Area || ""),
        "es",
        { sensitivity: "base" }
      );
      if (area !== 0) return area;

      const linea = String(a.Linea || "").localeCompare(
        String(b.Linea || ""),
        "es",
        { sensitivity: "base" }
      );
      if (linea !== 0) return linea;

      return String(a.Talla || "").localeCompare(String(b.Talla || ""), "es", {
        sensitivity: "base",
      });
    });

  // ===== Hoja Resumen por sucursal =====
  const dataResumen = [];

  Object.entries(resumenPorSucursal)
    .sort(([sucursalA], [sucursalB]) => {
      const a = sucursalA === "Sin Sucursal" ? "ZZZ_Sin Sucursal" : sucursalA;
      const b = sucursalB === "Sin Sucursal" ? "ZZZ_Sin Sucursal" : sucursalB;
      return a.localeCompare(b, "es", { sensitivity: "base" });
    })
    .forEach(([sucursal, lineas]) => {
      Object.entries(lineas)
        .sort(([lineaA], [lineaB]) =>
          String(lineaA).localeCompare(String(lineaB), "es", {
            sensitivity: "base",
          })
        )
        .forEach(([linea, tallasObj]) => {
          Object.entries(tallasObj)
            .sort(([keyA], [keyB]) => {
              const { variante: varA, talla: tallaA } =
                parseKeyVarianteTalla(keyA);
              const { variante: varB, talla: tallaB } =
                parseKeyVarianteTalla(keyB);

              const labelA =
                varA && varA !== "Sin variante"
                  ? `${tallaA} (${varA})`
                  : tallaA;
              const labelB =
                varB && varB !== "Sin variante"
                  ? `${tallaB} (${varB})`
                  : tallaB;

              return labelA.localeCompare(labelB, "es", {
                sensitivity: "base",
              });
            })
            .forEach(([keyVT, cantidad]) => {
              const { variante, talla } = parseKeyVarianteTalla(keyVT);
              const tallaLabel =
                variante && variante !== "Sin variante"
                  ? `${talla} (${variante})`
                  : talla;

              dataResumen.push({
                Sucursal: sucursal,
                Linea: linea,
                Talla: tallaLabel,
                Cantidad: cantidad,
              });
            });
        });
    });

  // Primero la hoja resumen general
  const hojasFinales = [
    {
      sheetData: dataResumenGeneral,
      sheetName: "Resumen General",
      sheetFilter: [
        "Departamento",
        "Sucursal",
        "Area",
        "Linea",
        "Talla",
        "Cantidad",
      ],
      sheetHeader: [
        "Departamento",
        "Sucursal",
        "Area",
        "Linea",
        "Talla",
        "Cantidad",
      ],
    },
    ...hojasExcel,
    {
      sheetData: dataResumen,
      sheetName: "Resumen",
      sheetFilter: ["Sucursal", "Linea", "Talla", "Cantidad"],
      sheetHeader: ["Sucursal", "Linea", "Talla", "Cantidad"],
    },
  ];

  const option = {
    fileName: "TallasPorSucursal",
    datas: hojasFinales,
  };

  const toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}

function importarArchivo(event) {
  const target = event.target;
  const name = target.name;
  let hojas = [];

  if (name === "file") {
    let reader = new FileReader();
    reader.readAsArrayBuffer(target.files[0]);

    reader.onloadend = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      workbook.SheetNames.forEach((sheetName) => {
        const XL_row_object = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        hojas.push({
          data: XL_row_object,
          sheetName,
        });
      });

      const A1 = hojas[0].data;

      // Mapas para búsqueda rápida
      const areasClientesMap = {};
      areasClientes.forEach((area) => {
        areasClientesMap[area.name.toLowerCase()] = area._id;
      });

      const departamentosMap = {};
      departamentos.forEach((dep) => {
        departamentosMap[dep.name.toLowerCase()] = dep._id;
      });

      // Contadores
      const nuevosColaboradores = [];
      const sinNombre = [];
      const sinArea = [];
      const sinDepartamento = [];

      for (const a of A1) {
        const nombreValido = a.Nombre?.trim() !== "";
        const contId = areasClientesMap[a.Area?.toLowerCase()];
        const conceptoId = departamentosMap[a.Departamento?.toLowerCase()];

        if (!nombreValido) {
          sinNombre.push(a);
          continue;
        }
        if (!contId) {
          sinArea.push(a.Area);
          continue;
        }
        if (!conceptoId) {
          sinDepartamento.push(a.Departamento);
          continue;
        }

        nuevosColaboradores.push({
          // id: uuidv4(),
          nombre: String(a.Nombre || "").trim(),
          estado: String(a.Estado || "NA").trim(),
          telefono: String(a.Telefono || "").trim(),
          numero: String(a.Numero || "").trim(),
          clientes: idClienteCol,
          departamentos: conceptoId,
          areasClientes: contId,
          sucursales: selectedSucursal,
        });
      }

      setInputFieldsColaboradores(nuevosColaboradores);

      // Guardar conteo para swal en guardado
      setConteoIgnorados({
        sinNombre: sinNombre.length,
        sinArea: sinArea.length,
        sinDepartamento: sinDepartamento.length,
      });

      // Mostrar mensaje si hubo errores de área o departamento
      if (sinArea.length > 0 || sinDepartamento.length > 0) {
        Swal.fire({
          title: "Datos no encontrados",
          html: `
            ${sinArea.length > 0 ? `Áreas no encontradas: <b>${sinArea.join(", ")}</b><br>` : ""}
            ${sinDepartamento.length > 0 ? `Departamentos no encontrados: <b>${sinDepartamento.join(", ")}</b>` : ""}
          `,
          icon: "warning",
          confirmButtonText: "Entendido",
        });
      }
    };
  }
}
const tallasOrdenadas = React.useMemo(() => {
  const list = Array.isArray(tallas) ? [...tallas] : [];

  const tieneVariante = (t) =>
    Array.isArray(t?.variantesTallas) &&
    t.variantesTallas.length > 0 &&
    String(t.variantesTallas?.[0]?.name || "").trim() !== "";

  // false (sin variante) primero, true (con variante) después
  list.sort((a, b) => Number(tieneVariante(a)) - Number(tieneVariante(b)));

  return list;
}, [tallas]);

const fetchVariantesTallas = async () => {
  try {
    const res = await axios.get(URL_VARIANTES_TALLAS, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    });
    setVariantesTallas(res.data || []);
  } catch (err) {
    console.log(err);
  }
};

const openNuevaTalla = async (mode, parentId, index, nombre = "") => {
  setTargetSubGrupoTalla({ mode, parentId, index });
  setNuevaTallaNombre(String(nombre || "").trim());
  setVariante("0");
  await fetchVariantesTallas();
  setModalNuevaTalla(true);
};

const guardarNuevaTalla = async () => {
  const nombre = String(nuevaTallaNombre || "").trim();

  if (!nombre) {
    Swal.fire("Falta dato", "Captura el nombre de la talla.", "warning");
    return;
  }

  try {
    setSavingTalla(true);

    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    // 🔸 Body: ajusta si tu backend espera otros campos
    const body = {
      name: nombre,
      variantesTallas: variante && variante !== "0" ? [variante] : [],
    };

    // 1) Crear talla en backend
    const res = await axios.post(URL_TALLAS, body, { headers });

    // Lo que regrese el backend
    let nueva = res.data;

    // 2) Asegurar que tenga la variante "poblada" para mostrar name en el Autocomplete
    // (si tu backend ya regresa variantesTallas con {name}, no hacemos nada)
    if (variante && variante !== "0") {
      const varianteObj = (variantesTallas || []).find(
        (v) => String(v._id) === String(variante)
      );

      const backendYaTraeNombre =
        Array.isArray(nueva?.variantesTallas) &&
        nueva.variantesTallas.length > 0 &&
        typeof nueva.variantesTallas[0] === "object" &&
        !!nueva.variantesTallas[0]?.name;

      if (!backendYaTraeNombre) {
        nueva = {
          ...nueva,
          variantesTallas: varianteObj ? [varianteObj] : [],
        };
      }
    } else {
      // sin variante
      nueva = { ...nueva, variantesTallas: [] };
    }

    // 3) Agregar al catálogo de tallas (evitar duplicados)
    setTallas((prev) => {
      const exists = (prev || []).some(
        (t) => String(t?._id) === String(nueva?._id)
      );
      return exists ? prev : [...(prev || []), nueva];
    });

    // 4) ✅ Seleccionar la nueva talla en el subgrupo correspondiente (create/edit)
    if (targetSubGrupoTalla?.parentId && typeof targetSubGrupoTalla?.index === "number") {
      const { mode, parentId, index } = targetSubGrupoTalla;

      if (mode === "edit") {
        actualizarSubGrupoEdit(parentId, index, "talla", nueva._id);
      } else {
        actualizarSubGrupo(parentId, index, "talla", nueva._id);
      }
    }

    // 5) Cerrar modal + limpiar
    setModalNuevaTalla(false);
    setNuevaTallaNombre("");
    setVariante("0");
    // si quieres limpiar también el target:
    // setTargetSubGrupoTalla(null);

    Swal.fire({
      icon: "success",
      title: "Listo",
      text: "Talla creada y seleccionada.",
      timer: 1200,
      showConfirmButton: false,
    });
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "No se pudo dar de alta la talla.", "error");
  } finally {
    setSavingTalla(false);
  }
};

const saveColaboradoresArchivo = async () => {
  const colaboradoresValidos = inputFieldsColaboradores.filter(
    (c) => c.nombre?.trim() !== ""
  );
  const totalIgnorados = inputFieldsColaboradores.length - colaboradoresValidos.length;

  if (colaboradoresValidos.length === 0) {
    return Swal.fire({
      icon: "warning",
      title: "Sin datos válidos",
      text: "No hay colaboradores con nombre para registrar.",
    });
  }

  const confirmacion = await Swal.fire({
    icon: "info",
    title: "¿Deseas continuar?",
   html: `
  Se van a registrar <b>${colaboradoresValidos.length}</b> colaboradores.<br><br>
  <b>Filas ignoradas:</b><br>
  ${conteoIgnorados.sinNombre > 0 ? `• ${conteoIgnorados.sinNombre} sin nombre<br>` : ""}
  ${conteoIgnorados.sinArea > 0 ? `• ${conteoIgnorados.sinArea} sin área válida<br>` : ""}
  ${conteoIgnorados.sinDepartamento > 0 ? `• ${conteoIgnorados.sinDepartamento} sin departamento válido<br>` : ""}
`,
    showCancelButton: true,
    confirmButtonText: "Sí, guardar",
    cancelButtonText: "Cancelar",
  });

  if (!confirmacion.isConfirmed) return;

  try {
    const { data } = await axios.post(
      `${URL_COLABORADORES_CLIENTES}/importar`,
      { colaboradores: colaboradoresValidos },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("app_token")}`,
        },
      }
    );

    Swal.fire({
      icon: "success",
      title: "Registro completado",
      html: `
        <b>${data.insertedCount || colaboradoresValidos.length}</b> colaboradores registrados correctamente.<br>
        ${totalIgnorados > 0 ? `<small>${totalIgnorados} renglón(es) fueron ignorados por estar vacíos.</small>` : ""}
      `
    });

    setInputFieldsColaboradores([]);
  } catch (err) {
    console.error("Error al guardar colaboradores:", err);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Hubo un problema al guardar los colaboradores.",
    });
  }
};

  const resumen = useMemo(() => {
    const total = inputFieldsSucArchivo.length;
    const sinAlias = inputFieldsSucArchivo.filter(
      (x) => !String(x.alias || "").trim()
    ).length;
    return { total, sinAlias };
  }, [inputFieldsSucArchivo]);

function importarArchivoSucursales(event) {
  const target = event.target;
  const name = target.name;
  let hojas = [];

  if (name === "file") {
    let reader = new FileReader();
    reader.readAsArrayBuffer(target.files[0]);

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      workbook.SheetNames.forEach((sheetName) => {
        const XL_row_object = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        hojas.push({
          data: XL_row_object,
          sheetName,
        });
      });

      const A1 = hojas[0].data;

      // Contadores
      const nuevasSucursales = [];
      const sinNombre = [];
      const sinArea = [];
      const sinDepartamento = [];

      for (const a of A1) {
        const nombreValido = a.Alias?.trim() !== "";

        nuevasSucursales.push({
          // id: uuidv4(),
          alias: String(a.Alias || "").trim(),
          responsable: String(a.Responsable || "NA").trim(),
          calle: String(a.Calle || "NA").trim(),
          numero_ext: String(a.NumeroExterior || "NA").trim(),
          numero_int: String(a.NumeroInterior || "NA").trim(),
          delegacion: String(a.Delegacion || "NA").trim(),
          estado: String(a.Estado || "NA").trim(),
          pais: String(a.Pais || "NA").trim(),
          cp: String(a.CP || 0).trim(),
          colonia: String(a.Colonia || "NA").trim(),
          ciudad: String(a.Ciudad || "NA").trim(),
          RFC: String(a.RFC || "NA").trim(),
          razon_social: String(a.RazonSocial || "NA").trim(),
          regFiscal: String(a.RegFiscal || 601).trim(),
          clientes: idClienteCol,
        });
      }

      setInputFieldsSucArchivo(nuevasSucursales);
      setModalSucursalesOpen(true);

    };
  }
}

async function saveSucursalesArchivo() {
  try {
    const edits = sucursales
      .filter((a) => String(a.alias || "").trim() !== "")
      .map((a) =>
        axios.patch(
          `${URL_SUCURSALES}/${a._id}`,
          {
            alias: a.alias,
            responsable: a.responsable,
            calle: a.calle,
            numero_ext: a.numero_ext,
            numero_int: a.numero_int,
            delegacion: a.delegacion,
            estado: a.estado,
            pais: a.pais,
            cp: a.cp,
            colonia: a.colonia,
            ciudad: a.ciudad,
            RFC: a.RFC,
            razon_social: a.razon_social,
            regFiscal: a.regFiscal,
          },
          {
            headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
          }
        )
      );

    const adds = inputFieldsSucArchivo
      .filter((a) => String(a.alias || "").trim() !== "")
      .map((a) =>
        axios.post(
          `${URL_SUCURSALES}`,
          {
            alias: a.alias,
            responsable: a.responsable,
            calle: a.calle,
            numero_ext: a.numero_ext,
            numero_int: a.numero_int,
            delegacion: a.delegacion,
            estado: a.estado,
            pais: a.pais,
            cp: a.cp,
            colonia: a.colonia,
            ciudad: a.ciudad,
            clientes: idClienteSucursal,
            RFC: a.RFC,
            razon_social: a.razon_social,
            regFiscal: a.regFiscal,
          },
          {
            headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
          }
        )
      );

    await Promise.all([...edits, ...adds]);

    await axios.post(
      URL_LOGS,
      {
        tipo: "Editar Sucursal",
        detalle: `Cliente ${idClienteSucursal} / Importación sucursales`,
        user: user.id,
      },
      {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      }
    );

    Swal.fire("Good job!", "Creado con éxito", "success");
    setTimeout(() => window.location.reload(), 1000);
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error?.response?.data || error.message}`,
    });
    console.log(error);
  }
}

function importarArchivoTallas(event) {
  const target = event.target;

  if (!target.files || !target.files[0]) return;

  if (!idClienteCol) {
    Swal.fire("Error", "No hay cliente seleccionado", "error");
    return;
  }

  if (
    !Array.isArray(areas) ||
    areas.length === 0 ||
    !Array.isArray(tallas) ||
    tallas.length === 0 ||
    !Array.isArray(sucursales) ||
    sucursales.length === 0 ||
    !Array.isArray(departamentos) ||
    departamentos.length === 0 ||
    !Array.isArray(subDepartamentos) ||
    subDepartamentos.length === 0
  ) {
    Swal.fire(
      "Error",
      "Aún no se cargan áreas, tallas o catálogos necesarios",
      "error"
    );
    return;
  }

  const normalize = (txt) =>
    String(txt ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

  const normalizeVariant = (txt) =>
    normalize(
      String(txt ?? "")
        .replace(/([a-zA-Z])([+-]\d+)/g, "$1 $2")
        .replace(/\s*([+-])\s*(\d+)/g, " $1$2")
        .replace(/\s+/g, " ")
        .trim()
    );

  const getCell = (row, posibles) => {
    for (const key of posibles) {
      if (row[key] !== undefined && row[key] !== null) {
        return row[key];
      }
    }
    return "";
  };

  const getId = (val) => {
    if (!val) return "";
    if (typeof val === "object") return val._id || val.id || "";
    return val;
  };

  // Busca la talla base más larga posible para soportar nombres compuestos
  const splitTallaVariante = (txt) => {
    const limpio = String(txt ?? "").replace(/\s+/g, " ").trim();
    if (!limpio) return { tallaBase: "", variante: "" };

    const limpioNorm = normalize(limpio);

    let mejorOriginal = "";
    let mejorNorm = "";

    (tallas || []).forEach((t) => {
      const nombreTalla = String(t?.name || "").trim();
      if (!nombreTalla) return;

      const nombreNorm = normalize(nombreTalla);

      if (
        limpioNorm === nombreNorm ||
        limpioNorm.startsWith(nombreNorm + " ")
      ) {
        if (nombreNorm.length > mejorNorm.length) {
          mejorNorm = nombreNorm;
          mejorOriginal = nombreTalla;
        }
      }
    });

    if (mejorOriginal) {
      const variante = limpio.slice(mejorOriginal.length).trim();
      return {
        tallaBase: mejorOriginal,
        variante,
      };
    }

    return {
      tallaBase: limpio,
      variante: "",
    };
  };

  const reader = new FileReader();
  reader.readAsArrayBuffer(target.files[0]);

  reader.onloadend = (e) => {
    try {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const json = XLSX.utils.sheet_to_json(
        workbook.Sheets[workbook.SheetNames[0]],
        { defval: "" }
      );

      if (!json.length) {
        Swal.fire("Error", "El archivo está vacío", "error");
        return;
      }

      // =========================
      // VARIANTES
      // =========================
      const variantesPorId = {};
      (variantesTallas || []).forEach((v) => {
        if (!v?._id) return;
        variantesPorId[String(v._id)] = {
          _id: v._id,
          name: String(v.name || "").trim(),
          norm: normalizeVariant(v.name || ""),
        };
      });

      // =========================
      // SUCURSALES
      // =========================
      const sucursalesMap = {};
      (sucursales || []).forEach((s) => {
        const clientesSucursal = Array.isArray(s.clientes) ? s.clientes : [];

        const perteneceCliente = clientesSucursal.some((c) => {
          return String(getId(c)) === String(idClienteCol);
        });

        if (perteneceCliente) {
          const alias = String(s?.alias ?? "").trim();
          if (alias) {
            sucursalesMap[normalize(alias)] = s._id;
          }
        }
      });

      if (Object.keys(sucursalesMap).length === 0) {
        (sucursales || []).forEach((s) => {
          const alias = String(s?.alias ?? "").trim();
          if (alias) {
            sucursalesMap[normalize(alias)] = s._id;
          }
        });
      }

      // =========================
      // ÁREAS SOLO DEL CLIENTE
      // =========================
      const areasMap = {};
      (areas || []).forEach((a) => {
        const clientesArea = Array.isArray(a.clientes) ? a.clientes : [];

        const perteneceCliente = clientesArea.some((c) => {
          return String(getId(c)) === String(idClienteCol);
        });

        if (perteneceCliente && a?.name) {
          areasMap[normalize(a.name)] = a._id;
        }
      });

      // =========================
      // DEPARTAMENTOS
      // =========================
      const departamentosMap = {};
      (departamentos || []).forEach((d) => {
        if (d?.name) {
          departamentosMap[normalize(d.name)] = d._id;
        }
      });

      // =========================
      // SUBDEPARTAMENTOS / LINEAS
      // =========================
      const subDepartamentosMap = {};
      (subDepartamentos || []).forEach((s) => {
        if (s?.name) {
          subDepartamentosMap[normalize(s.name)] = s._id;
        }
      });

      // =========================
      // TALLAS
      // =========================
      const tallasSimplesMap = {};
      const tallasConVarianteMap = {};
      const tallasBaseFallbackMap = {};

      (tallas || []).forEach((t) => {
        if (!t?._id || !t?.name) return;

        const tallaBase = String(t.name).trim();
        const tallaBaseNorm = normalize(tallaBase);

        const variantes = Array.isArray(t.variantesTallas)
          ? t.variantesTallas
          : [];

        const variantesResueltas = variantes
          .map((vt) => {
            if (typeof vt === "object" && vt !== null) {
              return {
                _id: vt._id,
                name: String(vt.name || "").trim(),
                norm: normalizeVariant(vt.name || ""),
              };
            }
            return variantesPorId[String(vt)] || null;
          })
          .filter(Boolean);

        if (!tallasBaseFallbackMap[tallaBaseNorm]) {
          tallasBaseFallbackMap[tallaBaseNorm] = t._id;
        }

        if (variantesResueltas.length === 0) {
          tallasSimplesMap[tallaBaseNorm] = t._id;
        }

        variantesResueltas.forEach((v) => {
          const comboKey = `${tallaBaseNorm}__${v.norm}`;
          tallasConVarianteMap[comboKey] = t._id;
        });
      });

      // =========================
      // COLUMNAS
      // =========================
      const columnas = Object.keys(json[0] || {});
      const idxTelefono = columnas.findIndex(
        (col) => normalize(col) === "telefono"
      );

      if (idxTelefono === -1) {
        Swal.fire(
          "Error",
          'No se encontró la columna "TELEFONO" en el archivo',
          "error"
        );
        return;
      }

      const columnasSub = columnas.slice(idxTelefono + 1);

      // =========================
      // ERRORES
      // =========================
      const sucursalesNoEncontradas = [];
      const areasNoEncontradas = [];
      const departamentosNoEncontrados = [];
      const lineasNoEncontradas = [];
      const tallasNoEncontradas = [];
      const variantesNoEncontradas = [];
      const filasSinNombre = [];

      const datosPreparados = json.map((row, index) => {
        const filaExcel = index + 2;

        const nombre = String(
          getCell(row, ["NOMBRE", "Nombre", "nombre", "NOMBRE "])
        ).trim();

        const telefonoRaw = String(
          getCell(row, ["TELEFONO", "Telefono", "telefono"])
        ).trim();

        const telefono = telefonoRaw || "NA";

        const numero = String(
          getCell(row, ["NUMERO", "Numero", "numero"])
        ).trim();

        const estado = String(
          getCell(row, ["ESTADO", "Estado", "estado"]) || "NA"
        ).trim();

        const sucursalTexto = String(
          getCell(row, ["SUCURSAL", "Sucursal", "sucursal"])
        ).trim();

        const areaTexto = String(
          getCell(row, ["AREA", "Area", "area"])
        ).trim();

        const departamentoTexto = String(
          getCell(row, ["DEPARTAMENTO", "Departamento", "departamento"])
        ).trim();

        const sucursalId = sucursalesMap[normalize(sucursalTexto)] || "";
        const areaId = areasMap[normalize(areaTexto)] || "";
        const departamentoId =
          departamentosMap[normalize(departamentoTexto)] || "";

        if (!nombre) {
          filasSinNombre.push(`Fila ${filaExcel}`);
        }

        if (sucursalTexto && !sucursalId) {
          sucursalesNoEncontradas.push(
            `Fila ${filaExcel}${nombre ? ` - ${nombre}` : ""}: ${sucursalTexto}`
          );
        }

        if (areaTexto && !areaId) {
          areasNoEncontradas.push(
            `Fila ${filaExcel}${nombre ? ` - ${nombre}` : ""}: ${areaTexto}`
          );
        }

        if (departamentoTexto && !departamentoId) {
          departamentosNoEncontrados.push(
            `Fila ${filaExcel}${nombre ? ` - ${nombre}` : ""}: ${departamentoTexto}`
          );
        }

        const tallasArray = [];

        columnasSub.forEach((col) => {
          const tallaTextoOriginal = String(row[col] ?? "").trim();
          if (!tallaTextoOriginal) return;

          const subDepartamentoId = subDepartamentosMap[normalize(col)] || "";
          if (!subDepartamentoId) {
            lineasNoEncontradas.push(
              `Fila ${filaExcel}${nombre ? ` - ${nombre}` : ""}: Línea "${String(
                col
              ).trim()}" con talla "${tallaTextoOriginal}"`
            );
            return;
          }

          let tallaId = "";

          const { tallaBase, variante } = splitTallaVariante(tallaTextoOriginal);
          const tallaBaseNorm = normalize(tallaBase);
          const varianteNorm = normalizeVariant(variante);

          if (!varianteNorm) {
            // Sin variante: sí puede usar talla simple o fallback a base
            tallaId =
              tallasSimplesMap[tallaBaseNorm] ||
              tallasBaseFallbackMap[tallaBaseNorm] ||
              "";
          } else {
            // Con variante: SOLO pasa si existe la combinación exacta
            const comboKey = `${tallaBaseNorm}__${varianteNorm}`;
            tallaId = tallasConVarianteMap[comboKey] || "";

            if (!tallaId) {
              const existeBase = !!tallasBaseFallbackMap[tallaBaseNorm];

              if (existeBase) {
                variantesNoEncontradas.push(
                  `Fila ${filaExcel}${nombre ? ` - ${nombre}` : ""}: Línea "${String(
                    col
                  ).trim()}" -> talla "${tallaBase}" con variante "${variante}" no encontrada`
                );
              } else {
                tallasNoEncontradas.push(
                  `Fila ${filaExcel}${nombre ? ` - ${nombre}` : ""}: Línea "${String(
                    col
                  ).trim()}" -> talla "${tallaTextoOriginal}"`
                );
              }
              return;
            }
          }

          if (!tallaId) {
            tallasNoEncontradas.push(
              `Fila ${filaExcel}${nombre ? ` - ${nombre}` : ""}: Línea "${String(
                col
              ).trim()}" -> talla "${tallaTextoOriginal}"`
            );
            return;
          }

          tallasArray.push({
            subDepartamento: String(col),
            subDepartamentoId,
            tallaTexto: tallaTextoOriginal,
            tallaId,
          });
        });

        return {
          nombre,
          telefono: String(telefono),
          numero,
          estado,
          sucursal: sucursalTexto,
          area: areaTexto,
          departamento: departamentoTexto,
          sucursalId,
          areaId,
          departamentoId,
          tallas: tallasArray,
        };
      });

      setColaboradoresImportar(datosPreparados);

      const unicos = (arr) => [...new Set(arr.filter(Boolean))];

      const filasSinNombreU = unicos(filasSinNombre);
      const sucursalesNoEncontradasU = unicos(sucursalesNoEncontradas);
      const areasNoEncontradasU = unicos(areasNoEncontradas);
      const departamentosNoEncontradosU = unicos(departamentosNoEncontrados);
      const lineasNoEncontradasU = unicos(lineasNoEncontradas);
      const tallasNoEncontradasU = unicos(tallasNoEncontradas);
      const variantesNoEncontradasU = unicos(variantesNoEncontradas);

      const totalErrores =
        filasSinNombreU.length +
        sucursalesNoEncontradasU.length +
        areasNoEncontradasU.length +
        departamentosNoEncontradosU.length +
        lineasNoEncontradasU.length +
        tallasNoEncontradasU.length +
        variantesNoEncontradasU.length;
const totalTallasLeidas = datosPreparados.reduce(
  (acc, col) => acc + (col.tallas?.length || 0),
  0
);
      if (totalErrores > 0) {
        Swal.fire({
          icon: "warning",
          title: "Archivo cargado con observaciones",
          width: 1000,
          html: `
            <div style="text-align:left; max-height:70vh; overflow-y:auto;">
              <b>Colaboradores leídos:</b> ${datosPreparados.length}<br><br>
              <b>Tallas leídas:</b> ${totalTallasLeidas}<br><br>

              ${
                filasSinNombreU.length
                  ? `<b>Filas sin nombre:</b><br>${filasSinNombreU
                      .slice(0, 20)
                      .join("<br>")}<br><br>`
                  : ""
              }

              ${
                sucursalesNoEncontradasU.length
                  ? `<b>Sucursales no encontradas:</b><br>${sucursalesNoEncontradasU
                      .slice(0, 30)
                      .join("<br>")}<br><br>`
                  : ""
              }

              ${
                areasNoEncontradasU.length
                  ? `<b>Áreas no encontradas:</b><br>${areasNoEncontradasU
                      .slice(0, 30)
                      .join("<br>")}<br><br>`
                  : ""
              }

              ${
                departamentosNoEncontradosU.length
                  ? `<b>Departamentos no encontrados:</b><br>${departamentosNoEncontradosU
                      .slice(0, 30)
                      .join("<br>")}<br><br>`
                  : ""
              }

              ${
                lineasNoEncontradasU.length
                  ? `<b>Líneas no encontradas:</b><br>${lineasNoEncontradasU
                      .slice(0, 50)
                      .join("<br>")}<br><br>`
                  : ""
              }

              ${
                variantesNoEncontradasU.length
                  ? `<b>Variantes no encontradas:</b><br>${variantesNoEncontradasU
                      .slice(0, 80)
                      .join("<br>")}<br><br>`
                  : ""
              }

              ${
                tallasNoEncontradasU.length
                  ? `<b>Tallas no encontradas:</b><br>${tallasNoEncontradasU
                      .slice(0, 80)
                      .join("<br>")}<br><br>`
                  : ""
              }
            </div>
          `,
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "Archivo cargado",
          text: `${datosPreparados.length} colaboradores listos para guardar`,
        });
      }
    } catch (error) {
      console.error("Error al importar archivo:", error);
      Swal.fire("Error", "Ocurrió un error al leer el archivo", "error");
    }
  };
}

async function saveImportacionTallas() {
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const validos = (colaboradoresImportar || []).filter(
    (c) =>
      c.nombre?.trim() &&
      c.sucursalId &&
      c.areaId &&
      c.departamentoId
  );

  if (!validos.length) {
    Swal.fire("Error", "No hay registros válidos para guardar", "error");
    return;
  }

Swal.fire({
  title: "Guardando...",
  html: "Favor de no cerrar ni refrescar la página",
  allowOutsideClick: false,
  showConfirmButton: false,
  didOpen: () => Swal.showLoading(),
});

  let guardadosColaboradores = 0;
  let guardadasTallas = 0;
  const errores = [];

  try {
    for (const c of validos) {
      let resColaborador;

      try {
        const payloadColaborador = {
          nombre: String(c.nombre || "").trim(),
          sucursales: [String(c.sucursalId)],
          estado: String(c.estado || "NA"),
          areasClientes: String(c.areaId),
          telefono: String(c.telefono || ""),
          numero: String(c.numero || ""),
          clientes: String(idClienteCol),
          departamentos: String(c.departamentoId),
        };

        resColaborador = await axios.post(
          URL_COLABORADORES_CLIENTES,
          payloadColaborador,
          { headers }
        );
      } catch (error) {
        console.error("Error guardando colaborador:", c.nombre, error?.response?.data || error);
        errores.push(`Colaborador: ${c.nombre}`);
        continue;
      }

      const colaboradorId =
        resColaborador?.data?._id ||
        resColaborador?.data?.id ||
        resColaborador?.data?.data?._id;

      if (!colaboradorId) {
        errores.push(`Sin _id: ${c.nombre}`);
        continue;
      }

      guardadosColaboradores++;

      for (const t of c.tallas || []) {
        if (!t.subDepartamentoId || !t.tallaId) continue;

        try {
          const payloadTalla = {
            tallas: [String(t.tallaId)],
            clientes: String(idClienteCol),
            observaciones: "NA",
            colaboradoresClientes: String(colaboradorId),
            departamentos: [String(c.departamentoId)],
            subDepartamentos: [String(t.subDepartamentoId)],
          };

          await axios.post(URL_COLABORADORES_TALLAS, payloadTalla, {
            headers,
          });

          guardadasTallas++;
        } catch (error) {
          console.error(
            "Error guardando talla:",
            c.nombre,
            t.subDepartamento,
            error?.response?.data || error
          );
          errores.push(
            `${c.nombre} -> ${t.subDepartamento}: ${t.tallaTexto || ""}`
          );
        }
      }
    }

    Swal.fire({
      icon: "success",
      title: "Importación terminada",
      html: `
        Colaboradores guardados: <b>${guardadosColaboradores}</b><br>
        Tallas guardadas: <b>${guardadasTallas}</b><br>
        Errores: <b>${errores.length}</b>
      `,
    });

  } catch (error) {
    console.error("Error general en saveImportacionTallas:", error);
    Swal.fire("Error", "Ocurrió un error al guardar", "error");
  }
}

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_clientes || user.tipo == "Cliente" ? (
        <div className="card col-12">
              <Row>
                <Col md={8}>
                  {user.clientes_create ? (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      href="/ClientesCreate"
                    >
                      Nuevo Cliente
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      disabled
                    >
                      Nuevo Cliente
                    </Button>
                  )}
                  {user.clientes_create ? (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      href="/ClientesCreateProspecto"
                    >
                      Nuevo Prospecto
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      disabled
                    >
                      Nuevo Prospecto
                    </Button>
                  )}
                  <Button
                    size="sm"
                    href="/MenuCatalogos"
                    className="btn btn-danger"
                    id="botonListado"
                    disabled={user?.tipo === "Cliente"}
                  >
                    Regresar
                  </Button>
                </Col>
                <Col sm={4}>
                  <ButtonGroup id="logoutBoton">
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={user?.tipo === "Cliente"}
                      onClick={PDFTabla}
                    >
                      PDF <i class="far fa-file-pdf"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      disabled={user?.tipo === "Cliente"}
                      onClick={toggleMail}
                      color="info"
                    >
                      eMail <i class="fas fa-at"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="primary"
                      disabled={user?.tipo === "Cliente"}
                      onClick={excel}
                    >
                      Excel <i class="far fa-file-excel"></i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
              <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                <ModalHeader toggle={toggleMail}>
                  <h4>Enviar Listado Clientes</h4>
                </ModalHeader>
                <ModalBody>
                  <Label className="mr-sm-2">Email</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={mailTo}
                    required
                    onChange={(e) => {
                      setMailTo(e.target.value);
                    }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button size="sm" color="success" onClick={enviaMail}>
                    Enviar
                  </Button>
                </ModalFooter>
              </Modal>
              <h3 align="center">Clientes</h3>
              <div className="row">
                <div className="col-md-8">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
                <div className="col-md-4 d-flex flex-row-reverse">
                  <Search
                    onSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
              {user.tipo !== "Cliente" ? (
                              <Row>
                <Col md={2}>
                  <Label>Zonas</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={grupo}
                    onChange={(e) => {
                      setGrupo(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    {grupos
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </Col>
                <Col md={2}>
                  <Label>Contacto</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={contacto}
                    onChange={(e) => {
                      setContacto(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {colaboradores
                      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.nombre} {a.apellido}
                          </option>
                        );
                      })}
                  </Input>
                </Col>
                <Col md={2}>
                  <Label>Activo</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={activo}
                    required
                    onChange={(e) => {
                      setActivo(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Activos</option>
                    <option value="No">Inactivos</option>
                  </Input>
                </Col>
              </Row>
              ):undefined}

              <br />
              <Table
                size="sm"
                striped
                borderless
                className="table-responsive-xl"
              >
                <TableHeader
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />
                <tbody>
                  {commentsData.map((p) => {
                    {
                      return (
                        <tr>
                          <td>{p.numero}</td>
                          <td>{p.nombre_comercial}</td>
                          <td>{p.telefono}</td>
                          <td>{p.email}</td>
                          <td>{p.grupo}</td>
                          <td>{p.contacto}</td>
                          <td>
                            <div>
                              {/* <Button
                              color="dany"
                              size="sm"
                              onClick={(e) => Info(p._id)}
                              id="Detalle"
                            >
                              <i class="fas fa-file-alt"></i>
                            </Button> */}
                              <Button
                                color="info"
                                id="Editar"
                                size="sm"
                                onClick={(e) => dir(p._id, p.nombre_comercial)}
                              >
                                <i class="fas fa-shipping-fast"></i>
                              </Button>
                              <Button
                                color="info"
                                id="Editar"
                                size="sm"
                                disabled={user?.tipo === "Cliente"}
                                onClick={(e) =>
                                  jalaInfo(
                                    p._id,
                                    p.telefono,
                                    p.email,
                                    p.calle,
                                    p.numero_ext,
                                    p.numero_int,
                                    p.pais,
                                    p.estado,
                                    p.ciudad,
                                    p.delegacion,
                                    p.colonia,
                                    p.cp,
                                    p.nombre_comercial,
                                    p.razon_social,
                                    p.RFC,
                                    p.grupo,
                                    p.idGrupo,
                                    p.contacto,
                                    p.idContacto,
                                    p.observaciones,
                                    p.ultimo_pago,
                                    p.forma_pago,
                                    p.usoCFDI,
                                    p.regFiscal,
                                    p.formaPagoSAT,
                                    p.condicionesPagoSAT,
                                    p.metodoPagoSAT,
                                    p.codigo,
                                    p.numero,
                                    p.plazo,
                                    p.condicionesCotizacion
                                  )
                                }
                              >
                                <i class="far fa-edit"></i>
                              </Button>

                              <Button
  color="warning"
  id="Editar"
  size="sm"
  disabled={user?.tipo === "Cliente"}
  onClick={() => {
    setSelectedClienteAreas(p._id);
    setModalAreas(true);
  }}
>
  <i className="fa-solid fa-shop"></i>
</Button>

                              {/* <Button
                              color="success"
                              size="sm"
                              onClick={(e) => jalaBoni(p._id, p.nombre_comercial)}
                              id="Detalle"
                            >
                              <i class="fas fa-percentage"></i>
                            </Button>

                            <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) =>
                                    cue(p._id, p.nombre_comercial)
                                  }
                                >
                                  <i class="fas fa-dollar-sign"></i>
                                </Button>

                                {p.fiscal == "Si"?(
                            <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={() => bajaFiscal(p._id)}
                            tabindex="-1"
                          >
                            F
                          </Button>
                          ):(
                            <Button
                            size="sm"
                            className="btn"
                            color="primary"
                            onClick={() => altaFiscal(p._id)}
                            tabindex="-1"
                          >
                            F
                          </Button>
                          )} */}
                              <Button
                                color="success"
                                size="sm"
                                onClick={(e) =>
                                  jalaColaboradores(p._id, p.nombre_comercial)
                                }
                                id="Detalle"
                              >
                                <i class="fas fa-user"></i>
                              </Button>

                                {user?.tipo === "Cliente" ? (
                                  <></>
                                ):(
                              <Baja
                                idStatus={p._id}
                                is_active={p.activo}
                                URL_BAJA={process.env.REACT_APP_URL_CLIENTES}
                              />
                                )}
                             
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </Table>
              <div className="col-md-6">
                <Pagination
                  total={totalItems}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
          <Modal size="xl" isOpen={abrirSucursal} toggle={() => setAbrirSucursal(!abrirSucursal)}>
            <ModalHeader toggle={() => setAbrirSucursal(!abrirSucursal)}>
              <h4><i className="fas fa-store"></i> Sucursales — {nombre_comercial}</h4>
            </ModalHeader>
            <ModalBody>
              <small style={{ color: "#666" }}>
                Aquí puedes registrar las sucursales del cliente con su dirección y datos fiscales (útil para entregas y facturación por sucursal).
              </small>
              <br /><br />
            <div className="card container col-md-12">
               <Row>
              <Col md={6}>
            <Label>Archivo</Label>
              <Input
                required
                type="file"
                name="file"
                id="file"
                onChange={(event) => importarArchivoSucursales(event)}
              />
            </Col>
            </Row>
              {sucursales.map((ao) => (
                <div key={ao._id}>
                  <Row>
                    <Col md={1}>
                      <Label className="mr-sm-2">Alias</Label>
                      <Input
                        // bsSize="sm"
                        name="alias"
                        type="text"
                        value={ao.alias}
                        required
                        onChange={(event) => {
                          handleChangeInputExistentesSuc(ao._id, event);
                        }}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">Responsable</Label>
                      <Input
                        // bsSize="sm"
                        name="Responsable"
                        type="text"
                        value={ao.responsable}
                        required
                        onChange={(event) => {
                          handleChangeInputExistentesSuc(ao._id, event);
                        }}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">Calle</Label>
                      <Input
                        // bsSize="sm"
                        name="calle"
                        type="text"
                        value={ao.calle}
                        required
                        onChange={(event) => {
                          handleChangeInputExistentesSuc(ao._id, event);
                        }}
                      />
                    </Col>

                    <Col md={1}>
                      <Label className="mr-sm-2"># Ext</Label>
                      <Input
                        // bsSize="sm"
                        name="numero_ext"
                        type="text"
                        value={ao.numero_ext}
                        required
                        onChange={(event) => {
                          handleChangeInputExistentesSuc(ao._id, event);
                        }}
                      />
                    </Col>
                    <Col md={1}>
                      <Label className="mr-sm-2"># Int</Label>
                      <Input
                        // bsSize="sm"
                        name="numero_int"
                        type="text"
                        value={ao.numero_int}
                        required
                        onChange={(event) => {
                          handleChangeInputExistentesSuc(ao._id, event);
                        }}
                      />
                    </Col>
                    <Col md={1}>
                      <Label className="mr-sm-2">Pais</Label>
                      <Input
                        // bsSize="sm"
                        name="pais"
                        type="text"
                        value={ao.pais}
                        required
                        onChange={(event) => {
                          handleChangeInputExistentesSuc(ao._id, event);
                        }}
                      />
                    </Col>
                    <Col md={1}>
                      <Label className="mr-sm-2">Estado</Label>
                      <Input
                        // bsSize="sm"
                        name="estado"
                        type="text"
                        value={ao.estado}
                        required
                        onChange={(event) => {
                          handleChangeInputExistentesSuc(ao._id, event);
                        }}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">Ciudad</Label>
                      <Input
                        // bsSize="sm"
                        name="ciudad"
                        type="text"
                        value={ao.ciudad}
                        required
                        onChange={(event) => {
                          handleChangeInputExistentesSuc(ao._id, event);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={2}>
                      <Label className="mr-sm-2">Delegacion</Label>
                      <Input
                        // bsSize="sm"
                        name="delegacion"
                        type="text"
                        value={ao.delegacion}
                        required
                        onChange={(event) => {
                          handleChangeInputExistentesSuc(ao._id, event);
                        }}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">Colonia</Label>
                      <Input
                        // bsSize="sm"
                        name="colonia"
                        type="text"
                        value={ao.colonia}
                        required
                        onChange={(event) => {
                          handleChangeInputExistentesSuc(ao._id, event);
                        }}
                      />
                    </Col>
                    <Col md={1}>
                      <Label className="mr-sm-2">CP</Label>
                      <Input
                        // bsSize="sm"
                        name="cp"
                        type="text"
                        value={ao.cp}
                        required
                        onChange={(event) => {
                          handleChangeInputExistentesSuc(ao._id, event);
                        }}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">RFC</Label>
                      <Input
                        // bsSize="sm"
                        name="RFC"
                        type="text"
                        value={ao.RFC}
                        required
                        onChange={(event) => {
                          handleChangeInputExistentesSuc(ao._id, event);
                        }}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">Razon Social</Label>
                      <Input
                        // bsSize="sm"
                        name="razon_social"
                        type="text"
                        value={ao.razon_social}
                        required
                        onChange={(event) => {
                          handleChangeInputExistentesSuc(ao._id, event);
                        }}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">Reg Fiscal</Label>
                      <Input
                        // bsSize="sm"
                        name="regFiscal"
                        type="select"
                        value={ao.regFiscal}
                        required
                        onChange={(event) => {
                          handleChangeInputExistentesSuc(ao._id, event);
                        }}
                      >
                        <option value="">Reg Fiscal</option>
                        <option value="0">0</option>
                        <option value="601">
                          601 General de Ley Personas Morales
                        </option>
                        <option value="603">
                          603 Personas Morales con Fines no Lucrativos
                        </option>
                        <option value="605">
                          605 Sueldos y Salarios e Ingresos Asimilados al
                          Salario
                        </option>
                        <option value="608">608 Demas Ingresos</option>
                        <option value="612">
                          612 Personas Fisicas con Actividad Empresarial
                        </option>
                        <option value="616">616 Sin Obligacion Fiscal</option>
                        <option value="621">621 Incorporacion Fiscal</option>
                        <option value="625">
                          625 Reg. de las act. emp. cpn ingresos a traves de
                          plat. tec.
                        </option>
                        <option value="626">
                          626 Regimen simplificado de Confianza
                        </option>
                      </Input>
                    </Col>
                    <Col md={1}>
                      <Label className="mr-sm-2">Alta / Baja</Label>
                      <br />
                      <Baja
                        idStatus={ao._id}
                        is_active={ao.is_active}
                        URL_BAJA={process.env.REACT_APP_URL_SUCURSALES}
                      />
                    </Col>
                  </Row>
                  <br />
                </div>
              ))}

              {/* Agregar mas direcciones */}

              {inputFields.map((inputField) => (
                <div key={inputField.id}>
                  <Row>
                    <Col md={1}>
                      <Label className="mr-sm-2">Alias</Label>
                      <Input
                        // bsSize="sm"
                        name="alias"
                        type="text"
                        value={inputField.alias}
                        required
                        onChange={(event) => {
                          handleChangeInputSuc(inputField.id, event);
                        }}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">Responsable</Label>
                      <Input
                        // bsSize="sm"
                        name="Responsable"
                        type="text"
                        value={inputField.responsable}
                        required
                        onChange={(event) => {
                          handleChangeInputSuc(inputField.id, event);
                        }}
                      />
                    </Col>

                    <Col md={2}>
                      <Label className="mr-sm-2">Calle</Label>
                      <Input
                        // bsSize="sm"
                        name="calle"
                        type="text"
                        value={inputField.calle}
                        required
                        onChange={(event) => {
                          handleChangeInputSuc(inputField.id, event);
                        }}
                      />
                    </Col>

                    <Col md={1}>
                      <Label className="mr-sm-2"># Ext</Label>
                      <Input
                        // bsSize="sm"
                        name="numero_ext"
                        type="text"
                        value={inputField.numero_ext}
                        required
                        onChange={(event) => {
                          handleChangeInputSuc(inputField.id, event);
                        }}
                      />
                    </Col>
                    <Col md={1}>
                      <Label className="mr-sm-2"># Int</Label>
                      <Input
                        // bsSize="sm"
                        name="numero_int"
                        type="text"
                        value={inputField.numero_int}
                        required
                        onChange={(event) => {
                          handleChangeInputSuc(inputField.id, event);
                        }}
                      />
                    </Col>
                    <Col md={1}>
                      <Label className="mr-sm-2">Pais</Label>
                      <Input
                        // bsSize="sm"
                        name="pais"
                        type="text"
                        value={inputField.pais}
                        required
                        onChange={(event) => {
                          handleChangeInputSuc(inputField.id, event);
                        }}
                      />
                    </Col>
                    <Col md={1}>
                      <Label className="mr-sm-2">Estado</Label>
                      <Input
                        // bsSize="sm"
                        name="estado"
                        type="text"
                        value={inputField.estado}
                        required
                        onChange={(event) => {
                          handleChangeInputSuc(inputField.id, event);
                        }}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">Ciudad</Label>
                      <Input
                        // bsSize="sm"
                        name="ciudad"
                        type="text"
                        value={inputField.ciudad}
                        required
                        onChange={(event) => {
                          handleChangeInputSuc(inputField.id, event);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={2}>
                      <Label className="mr-sm-2">Delegacion</Label>
                      <Input
                        // bsSize="sm"
                        name="delegacion"
                        type="text"
                        value={inputField.delegacion}
                        required
                        onChange={(event) => {
                          handleChangeInputSuc(inputField.id, event);
                        }}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">Colonia</Label>
                      <Input
                        // bsSize="sm"
                        name="colonia"
                        type="text"
                        value={inputField.colonia}
                        required
                        onChange={(event) => {
                          handleChangeInputSuc(inputField.id, event);
                        }}
                      />
                    </Col>
                    <Col md={1}>
                      <Label className="mr-sm-2">CP</Label>
                      <Input
                        // bsSize="sm"
                        name="cp"
                        type="text"
                        value={inputField.cp}
                        required
                        onChange={(event) => {
                          handleChangeInputSuc(inputField.id, event);
                        }}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">RFC</Label>
                      <Input
                        // bsSize="sm"
                        name="RFC"
                        type="text"
                        value={inputField.RFC}
                        required
                        onChange={(event) => {
                          handleChangeInputSuc(inputField.id, event);
                        }}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">Razon Social</Label>
                      <Input
                        // bsSize="sm"
                        name="razon_social"
                        type="text"
                        value={inputField.razon_social}
                        required
                        onChange={(event) => {
                          handleChangeInputSuc(inputField.id, event);
                        }}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">Reg Fiscal</Label>
                      <Input
                        // bsSize="sm"
                        name="regFiscal"
                        type="select"
                        value={inputField.regFiscal}
                        required
                        onChange={(event) => {
                          handleChangeInputSuc(inputField.id, event);
                        }}
                      >
                        <option value="">Reg Fiscal</option>
                        <option value="0">0</option>
                        <option value="601">
                          601 General de Ley Personas Morales
                        </option>
                        <option value="603">
                          603 Personas Morales con Fines no Lucrativos
                        </option>
                        <option value="605">
                          605 Sueldos y Salarios e Ingresos Asimilados al
                          Salario
                        </option>
                        <option value="608">608 Demas Ingresos</option>
                        <option value="612">
                          612 Personas Fisicas con Actividad Empresarial
                        </option>
                        <option value="616">616 Sin Obligacion Fiscal</option>
                        <option value="621">621 Incorporacion Fiscal</option>
                        <option value="625">
                          625 Reg. de las act. emp. cpn ingresos a traves de
                          plat. tec.
                        </option>
                        <option value="626">
                          626 Regimen simplificado de Confianza
                        </option>
                      </Input>
                    </Col>
                    <Col md={1}>
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={handleAddFieldsSuc}
                        tabindex="-1"
                      >
                        <i class="fas fa-plus"></i>
                      </Button>
                    </Col>
                  </Row>
                  <br />
                </div>
              ))}
            </div>
            </ModalBody>
            <ModalFooter>
              <Button color="success" onClick={saveDireccion}>
                Guardar
              </Button>
              <Button color="secondary" onClick={() => setAbrirSucursal(false)}>
                Cerrar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      ) : undefined}
      <br />

      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Informacion del Cliente</h4>{" "}
        </ModalHeader>
        <ModalBody>
          <ClientesInfo idCliente={idInfo} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={toggle}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="xl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar cliente {numero} {nombre_comercial}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            {/* <Col md={3}>
              <Label>Codigo</Label>
              <Input
                type="text"
                placeholder="Codigo"
                value={codigo}
                required
                onChange={(e) => {
                  setCodigo(e.target.value);
                }}
              />
            </Col> */}
            <Col md={3}>
              <Label>Nombre Comercial</Label>
              <Input
                type="text"
                placeholder="Nombre Comercial"
                value={nombre_comercial}
                required
                onChange={(e) => {
                  setNombreComercial(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Razon Social</Label>
              <Input
                type="text"
                placeholder="Razon Social"
                value={razon_social}
                required
                onChange={(e) => {
                  setRazonSocial(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>RFC</Label>
              <Input
                type="text"
                placeholder="RFC"
                value={RFC}
                required
                onChange={(e) => {
                  setRFC(e.target.value);
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col md={8}>
              <Label>Calle</Label>
              <Input
                type="text"
                placeholder="Calle"
                value={calle}
                required
                onChange={(e) => {
                  setCalle(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>No. Ext</Label>
              <Input
                type="text"
                placeholder="No. Ext"
                value={numero_ext}
                required
                onChange={(e) => {
                  setNumeroExt(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>No. Int</Label>
              <Input
                type="text"
                placeholder="No. Int"
                value={numero_int}
                required
                onChange={(e) => {
                  setNumeroInt(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label>Pais</Label>
              <Input
                type="text"
                placeholder="Pais"
                value={pais}
                required
                onChange={(e) => {
                  setPais(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Estado</Label>
              <Input
                type="text"
                placeholder="Estado"
                value={estado}
                required
                onChange={(e) => {
                  setEstado(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Ciudad</Label>
              <Input
                type="text"
                placeholder="Ciudad"
                value={ciudad}
                required
                onChange={(e) => {
                  setCiudad(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label>Delegacion</Label>
              <Input
                type="text"
                placeholder="Delegacion o Municipio"
                value={delegacion}
                required
                onChange={(e) => {
                  setDelegacion(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Colonia</Label>
              <Input
                type="text"
                placeholder="Colonia"
                value={colonia}
                required
                onChange={(e) => {
                  setColonia(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>CP</Label>
              <Input
                type="text"
                placeholder="CP"
                value={cp}
                required
                onChange={(e) => {
                  setCP(e.target.value);
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Label>Telefono</Label>
              <Input
                type="text"
                placeholder="Telefono"
                value={telefono}
                required
                onChange={(e) => {
                  setTelefono(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Email</Label>
              <Input
                type="email"
                placeholder="Email"
                value={email}
                required
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Zona</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedGrupo}
                required
                onChange={(e) => {
                  setSelectedGrupo(e.target.value);
                }}
              >
                <option value="0">Selecciona una Zona</option>
                {grupos
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={3}>
              <Label className="mr-sm-2">Contacto Interno</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedContacto}
                required
                onChange={(e) => {
                  setSelectedContacto(e.target.value);
                }}
              >
                <option value="0">Selecciona un Contacto</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>Forma de Pago</Label>
              <Input
                type="select"
                placeholder="Forma de Pago"
                value={forma_pago}
                required
                onChange={(e) => {
                  setFormaPago(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Efectivo">Efectivo</option>
                <option value="Deposito">Deposito</option>
                <option value="Cheque">Cheque</option>
                <option value="PorDefinir">Por Definir</option>
              </Input>
            </Col>
            <Col md={3}>
              <Label>Plazo</Label>
              <Input
                type="select"
                placeholder="Plazo"
                value={plazo}
                required
                onChange={(e) => {
                  setPlazo(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                <option value="0">0</option>
                <option value="30">30</option>
                <option value="60">60</option>
                <option value="90">90</option>
                <option value="120">120</option>
                <option value="150">150</option>
              </Input>
            </Col>
            <Col md={3}>
              <Label>Regimen Fiscal</Label>
              <Input
                type="select"
                placeholder="RegFiscal"
                value={regFiscal}
                required
                onChange={(e) => {
                  setRegFiscal(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                <option value="0">0</option>
                <option value="601">601 General de Ley Personas Morales</option>
                <option value="603">
                  603 Personas Morales con Fines no Lucrativos
                </option>
                <option value="605">
                  605 Sueldos y Salarios e Ingresos Asimilados al Salario
                </option>
                <option value="608">608 Demas Ingresos</option>
                <option value="612">
                  612 Personas Físicas con Actividades Empresariales y
                  Profesionales
                </option>
                <option value="616">616 Sin Obligacion Fiscal</option>
                <option value="621">621 Incorporacion Fiscal</option>
                <option value="624">624 Régimen de los Coordinados</option>
                <option value="625">
                  625 Reg. de las act. emp. cpn ingresos a traves de plat. tec.
                </option>
                <option value="626">
                  626 Regimen simplificado de Confianza
                </option>
              </Input>
            </Col>

            <Col md={3}>
              <Label for="exampleEmail" className="mr-sm-2">
                Uso de CDFI
              </Label>
              <Input
                type="select"
                placeholder="Uso de CDFI"
                value={usoCFDI}
                required
                onChange={(e) => {
                  setusoCFDI(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                <option value="G01">G01 Adquisición de mercancías</option>
                <option value="G03">G03 Gastos en general</option>
                <option value="S01">S01 Sin efectos fiscales</option>
              </Input>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>Forma Pago Fiscal</Label>
              <Input
                type="select"
                value={formaPagoSAT}
                required
                onChange={(e) => {
                  setFormaPagoSAT(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                <option value="01"> 01 Efectivo</option>
                <option value="02"> 02 Cheque nominativo</option>
                <option value="03">
                  {" "}
                  03 Transferencia electrónica de fondos
                </option>
                <option value="04"> 04 Tarjeta de crédito</option>
                <option value="05"> 05 Monedero electrónico</option>
                <option value="06"> 06 Dinero electrónico</option>
                <option value="08"> 08 Vales de despensa</option>
                <option value="12"> 12 Dación en pago</option>
                <option value="13"> 13 Pago por subrogación</option>
                <option value="14"> 14 Pago por consignación</option>
                <option value="15"> 15 Condonación</option>
                <option value="17"> 17 Compensación</option>
                <option value="23"> 23 Novación</option>
                <option value="24"> 24 Confusión</option>
                <option value="25"> 25 Remisión de deuda</option>
                <option value="26"> 26 Prescripción o caducidad</option>
                <option value="27"> 27 A satisfacción del acreedor</option>
                <option value="28"> 28 Tarjeta de débito</option>
                <option value="29"> 29 Tarjeta de servicios</option>
                <option value="30"> 30 Aplicación de anticipos</option>
                <option value="99"> 99 Por definir</option>
              </Input>
            </Col>

            <Col md={3}>
              <Label>Metodo Pago Fiscal</Label>
              <Input
                type="select"
                value={metodoPagoSAT}
                required
                onChange={(e) => {
                  setMetodoPagoSAT(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                <option value="PUE">PUE (Pago de Una Sola Exhibición)</option>
                <option value="PPD">
                  PPD (Pago en Parcialidades o Diferido)
                </option>
              </Input>
            </Col>

            <Col md={3}>
              <Label>Condiciones de Pago Fiscal</Label>
              <Input
                type="text"
                value={condicionesPagoSAT}
                required
                onChange={(e) => {
                  setCondicionesPagoSAT(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Label for="exampleEmail" className="mr-sm-2">
                Condiciones Cotizacion
              </Label>
              <Input
                type="textarea"
                placeholder="Condiciones Cotizacion"
                value={condicionesCotizacion}
                required
                onChange={(e) => {
                  setCondicionesCotizacion(e.target.value);
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editClientes}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="xl" isOpen={modalBoni} toggle={toggleBoni}>
        <ModalHeader toggle={toggleBoni}>
          <h4>Bonificaciones {clienteBoniName}</h4>
        </ModalHeader>
        <ModalBody>
          <Table striped borderless>
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Concepto</th>
                <th>Fijo</th>
                <th>Porcentaje</th>
                {/* <th>Importe</th> */}
                <th>Observaciones</th>
              </tr>
            </thead>
            <tbody>
              {boniCliente.map((a) => (
                <tr>
                  <td>
                    <Input
                      type="date"
                      name="fecha"
                      value={a.fecha}
                      key={a.id}
                      onChange={(e) => {
                        handleChangeInputExistentes(a.id, e);
                      }}
                    />
                  </td>
                  <td>
                    <Input
                      name="concepto"
                      type="select"
                      value={a.concepto}
                      required
                      onChange={(event) => {
                        handleChangeInputExistentes(a.id, event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {conceptosBonificaciones.map((cb) => {
                        return <option value={cb._id}>{cb.name}</option>;
                      })}
                    </Input>
                  </td>
                  <td>
                    <Input
                      type="select"
                      name="fijo"
                      value={a.fijo}
                      key={a.id}
                      onChange={(e) => {
                        handleChangeInputExistentes(a.id, e);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="Si">Si</option>
                      <option value="No">No</option>
                    </Input>
                  </td>
                  <td>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      name="porcentaje"
                      value={a.porcentaje}
                      key={a.id}
                      onChange={(e) => {
                        handleChangeInputExistentes(a.id, e);
                      }}
                    />
                  </td>
                  {/* <td>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            name="importe"
                            value={a.importe}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputExistentes(a.id, e);
                            }}
                          />
                        </td> */}
                  <td>
                    <Input
                      type="text"
                      name="observaciones"
                      value={a.observaciones}
                      key={a.id}
                      onChange={(e) => {
                        handleChangeInputExistentes(a.id, e);
                      }}
                    />
                  </td>
                  <td>
                    {a.is_active == "Si" ? (
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={() => bajaBoni(a.id)}
                        tabindex="-1"
                      >
                        <i class="far fa-times-circle"></i>
                      </Button>
                    ) : (
                      <Button
                        size="sm"
                        className="btn"
                        color="primary"
                        onClick={() => altaBoni(a.id)}
                        tabindex="-1"
                      >
                        <i class="far fa-check-circle"></i>
                      </Button>
                    )}
                  </td>
                </tr>
                // </div>
              ))}

              {inputFields.map((a) => (
                <tr>
                  <td>
                    <Input
                      type="date"
                      name="fecha"
                      value={a.fecha}
                      key={a.id}
                      onChange={(e) => {
                        handleChangeInput(a.id, e);
                      }}
                    />
                  </td>
                  <td>
                    <Input
                      name="concepto"
                      type="select"
                      value={a.concepto}
                      required
                      onChange={(event) => {
                        handleChangeInput(a.id, event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {conceptosBonificaciones.map((cb) => {
                        return <option value={cb._id}>{cb.name}</option>;
                      })}
                    </Input>
                  </td>
                  <td>
                    <Input
                      type="select"
                      name="fijo"
                      value={a.fijo}
                      key={a.id}
                      onChange={(e) => {
                        handleChangeInput(a.id, e);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="Si">Si</option>
                      <option value="No">No</option>
                    </Input>
                  </td>
                  <td>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      name="porcentaje"
                      value={a.porcentaje}
                      key={a.id}
                      onChange={(e) => {
                        handleChangeInput(a.id, e);
                      }}
                    />
                  </td>
                  {/* <td>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            name="importe"
                            value={a.importe}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInput(a.id, e);
                            }}
                          />
                        </td> */}
                  <td>
                    <Input
                      type="text"
                      name="observaciones"
                      value={a.observaciones}
                      key={a.id}
                      onChange={(e) => {
                        handleChangeInput(a.id, e);
                      }}
                    />
                  </td>
                  <td>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(a.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </td>
                </tr>
                // </div>
              ))}
            </tbody>
            <br />
          </Table>
          <br />
          <Row>
            <Button className="btn btn-success" onClick={saveBoni}>
              Registrar
            </Button>
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            Este proceso puede tardar varios segundos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size="xl" isOpen={modalCuenta} toggle={toggleCuenta}>
        <ModalHeader toggle={toggleCuenta}>
          <h4>Cuentas {nombre_comercial}</h4>
        </ModalHeader>
        <ModalBody>
          <Table striped borderless>
            <thead>
              <tr>
                <th>Banco</th>
                <th>RFC</th>
                <th>Cuentas</th>
              </tr>
            </thead>
            <tbody>
              {cuentas.map((a) => (
                <tr>
                  <td>
                    <Input
                      type="text"
                      name="banco"
                      value={a.banco}
                      key={a._id}
                      onChange={(e) => {
                        handleChangeInputCuentasExistentes(a._id, e);
                      }}
                    />
                  </td>
                  <td>
                    <Input
                      type="text"
                      name="rfc"
                      value={a.rfc}
                      key={a._id}
                      onChange={(e) => {
                        handleChangeInputCuentasExistentes(a._id, e);
                      }}
                    />
                  </td>
                  <td>
                    <Input
                      name="cuenta"
                      type="text"
                      value={a.cuenta}
                      required
                      // maxLength="4" // Limit to 4 digits
                      // pattern="\d{1,4}"
                      onChange={(event) => {
                        handleChangeInputCuentasExistentes(a._id, event);
                      }}
                    />
                  </td>
                  <td>
                    {a.is_active == "Si" ? (
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={() => bajaCuenta(a._id)}
                        tabindex="-1"
                      >
                        <i class="far fa-times-circle"></i>
                      </Button>
                    ) : (
                      <Button
                        size="sm"
                        className="btn"
                        color="primary"
                        onClick={() => altaCuenta(a._id)}
                        tabindex="-1"
                      >
                        <i class="far fa-check-circle"></i>
                      </Button>
                    )}
                  </td>
                </tr>
                // </div>
              ))}

              {inputFieldsCuentas.map((a) => (
                <tr>
                  <td>
                    <Input
                      type="text"
                      name="banco"
                      value={a.banco}
                      key={a.id}
                      onChange={(e) => {
                        handleChangeInputCuentas(a.id, e);
                      }}
                    />
                  </td>
                  <td>
                    <Input
                      type="text"
                      name="rfc"
                      value={a.rfc}
                      key={a._id}
                      onChange={(e) => {
                        handleChangeInputCuentas(a.id, e);
                      }}
                    />
                  </td>
                  <td>
                    <Input
                      name="cuenta"
                      type="text"
                      value={a.cuenta}
                      required
                      // maxLength="4" // Limit to 4 digits
                      // pattern="\d{1,4}"
                      onChange={(event) => {
                        handleChangeInputCuentas(a.id, event);
                      }}
                    />
                  </td>
                  <td>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={a.length === 1}
                      onClick={() => handleRemoveFieldsCuentas(a.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFieldsCuentas}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </td>
                </tr>
                // </div>
              ))}
            </tbody>
            <br />
          </Table>
          <br />
          <Row>
            <Button className="btn btn-success" onClick={saveCuenta}>
              Registrar
            </Button>
          </Row>
        </ModalBody>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalColaboradores}
        toggle={toggleColaboradores}
      >
        <ModalHeader toggle={toggleColaboradores}>
          <h4>Colaboradores {nombre_comercial}</h4>
        </ModalHeader>
        <ModalBody>
          <Row className="mb-3">
            <Col sm={8}>
              <Button
                color="primary"
                size="sm"
                onClick={() => setMostrarFormularioNuevo(true)}
              >
                <i className="fas fa-user-plus"></i> Nuevo
              </Button>
              <Button color="warning" size="sm" onClick={toggleArchivo}>
                <i className="fas fa-upload"></i> Subir Archivo Colaboradores
              </Button>
                <Button color="info" size="sm" onClick={toggleArchivoTallas}>
                <i className="fas fa-upload"></i> Subir Archivo Tallas
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTallasPorSucursal}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={ExcelTallasPorSucursal}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Table striped borderless>
            <thead>
              <tr>
                <th>Numero</th>
                <th>Departamento</th>
                <th>Nombre</th>
                {/* <th>Estado</th> */}
                <th>Sucursal</th>
                <th>Area</th>
                <th>Telefono</th>
              </tr>
            </thead>
            <tbody>
              {mostrarFormularioNuevo && (
                <>
                  <h3>Nuevos</h3>

                  {inputFieldsColaboradores.map((a) => (
                    <React.Fragment key={a.id}>
                      <tr>
                        <td>
                          <Input
                            type="text"
                            name="numero"
                            value={a.numero}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputColaboradores(a.id, e);
                            }}
                          />
                          <small className="text-muted">Numero</small>
                        </td>
                        <td>
                          <Input
                            className="col-sm-12"
                            type="select"
                            name="selectedDepartamento"
                            value={a.selectedDepartamento || "0"}
                            required
                            onChange={(e) =>
                              handleChangeInputColaboradores(a.id, e)
                            }
                          >
                            <option value="0">Selecciona</option>
                            {departamentos
                              .sort((a, b) => (a.name > b.name ? 1 : -1))
                              .map((dep) => (
                                <option key={dep._id} value={dep._id}>
                                  {dep.name}
                                </option>
                              ))}
                          </Input>
                          <small className="text-muted">Departamento</small>
                        </td>
                        <td>
                          <Input
                            type="text"
                            name="nombre"
                            value={a.nombre}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputColaboradores(a.id, e);
                            }}
                          />
                          <small className="text-muted">Nombre</small>
                        </td>
                        {/* <td>
                          <Input
                            type="text"
                            name="estado"
                            value={a.estado}
                            required
                            onChange={(e) => {
                              handleChangeInputColaboradores(a.id, e);
                            }}
                          />
                           
                          <small className="text-muted">Estado</small>
                        </td> */}
                        <td>
                          <Input
                            className="col-sm-12"
                            type="select"
                            name="selectedSucursal" // Debe coincidir
                            value={a.selectedSucursal || "0"}
                            required
                            onChange={(e) =>
                              handleChangeInputColaboradores(a.id, e)
                            }
                          >
                            <option value="0">Selecciona</option>
                            {sucursales
                              .sort((a, b) => (a.alias > b.alias ? 1 : -1))
                              .map((s) => (
                                <option key={s._id} value={s._id}>
                                  {s.alias}
                                </option>
                              ))}
                          </Input>
                          <small className="text-muted">Sucursal</small>
                        </td>
                        <td>
                          <Input
                            type="select"
                            name="selectedArea"
                            value={a.selectedArea || "0"}
                            onChange={(e) =>
                              handleChangeInputColaboradores(a.id, e)
                            }
                          >
                            <option value="">Selecciona un área</option>
                            {areasClientes.map((area) => (
                              <option key={area._id} value={area._id}>
                                {area.name}
                              </option>
                            ))}
                          </Input>
                          <small className="text-muted">Área</small>
                        </td>

                        <td>
                          <Input
                            type="text"
                            name="telefono"
                            value={a.telefono}
                            key={a._id}
                            onChange={(e) => {
                              handleChangeInputColaboradores(a.id, e);
                            }}
                          />
                          <small className="text-muted">Telefono</small>
                        </td>
                        <td>
                          <Button
                            size="sm"
                            color={
                              mostrarSubTallas[a.id] ? "secondary" : "info"
                            }
                            onClick={() => toggleSubTallas(a.id)}
                          >
                            <i className="fas fa-ruler-combined"></i>
                          </Button>
                          {/* <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        disabled={a.length === 1}
                        onClick={() => handleRemoveFieldsColaboradores(a.id)}
                        tabindex="-1"
                      >
                        <i class="fas fa-minus"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={handleAddFieldsColaboradores}
                        tabindex="-1"
                      >
                        <i class="fas fa-plus"></i>
                      </Button> */}
                        </td>
                      </tr>{" "}
                      {/* Renglón desplegable con subdepartamentos y tallas */}
                      {mostrarSubTallas[a.id] && (
                        <tr>
                          <td colSpan="100%">
                            <div>
                              <h6 className="fw-bold">Tallas por Linea</h6>

                              {(colaboradoresTallasNuevos[a.id] || [])
                              
                              .map(
                                (grupo, index) => (
                                  <Row
                                    key={index}
                                    className="align-items-center mb-2"
                                  >
                                    <Col md={3}>
                                      <Label>Linea</Label>
                                      <Input
                                        type="select"
                                        value={grupo.subDepartamento}
                                        onChange={(e) =>
                                          actualizarSubGrupo(
                                            a.id,
                                            index,
                                            "subDepartamento",
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value="">Selecciona</option>
                                        {subDepartamentos
                                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                                        .map((s) => (
                                          <option key={s._id} value={s._id}>
                                            {s.name}
                                          </option>
                                        ))}
                                      </Input>
                                    </Col>
                                    <Col md={3}>
  <Label>Talla</Label>

  <Autocomplete
    size="small"
value={tallasOrdenadas.find(t => String(t._id) === String(grupo.talla)) || null}
options={tallasOrdenadas}

    // ✅ para que salga "Dar de alta..."
filterOptions={(options, params) => {
  const filtered = filter(options, params);
  const inputValue = String(params.inputValue || "").trim();

  if (inputValue) {
    const alreadyExists = tallasOrdenadas.some((opt) => {
      const base = String(opt?.name || opt?.nombre || "").trim().toLowerCase();
      return base === inputValue.toLowerCase();
    });

    if (!alreadyExists) {
      filtered.push({
        inputValue,
        title: `Dar de alta "${inputValue}"`,
      });
    }
  }

  return filtered;
}}

    getOptionLabel={(opt) => {
      if (typeof opt === "string") return opt;
      if (opt?.inputValue) return opt.inputValue;

      const base = String(opt?.name || opt?.nombre || "").trim();
      const varName = opt?.variantesTallas?.[0]?.name ? String(opt.variantesTallas[0].name).trim() : "";
      return varName ? `${base} ${varName}` : base;
    }}

    renderOption={(option) => {
      if (option?.title) return option.title;

      return (
        <span>
          {option?.name || option?.nombre}{" "}
          <span className="text-muted">{option?.variantesTallas?.[0]?.name || ""}</span>
        </span>
      );
    }}

    onChange={(e, newValue) => {
      if (!newValue) {
        actualizarSubGrupo(a.id, index, "talla", "");
        return;
      }

      // si eligió "Dar de alta"
      if (newValue?.inputValue) {
        openNuevaTalla(a.id, index, newValue.inputValue);
        return;
      }

      // si por alguna razón llega string
      if (typeof newValue === "string") {
        openNuevaTalla(a.id, index, newValue);
        return;
      }

      // talla normal
      actualizarSubGrupo(a.id, index, "talla", newValue._id);
    }}

    renderInput={(params) => (
      <TextField
        {...params}
        label="Busca talla"
        variant="outlined"
        placeholder="Escribe para buscar o dar de alta"
      />
    )}
  />
</Col>
<Col md={3}>
                                      <Label>Observaciones</Label>
                                      <Input
                                        type="text"
                                        value={grupo.observaciones}
                                        onChange={(e) =>
                                          actualizarSubGrupo(
                                            a.id,
                                            index,
                                            "observaciones",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Col>

                                    <Col md={2}>
                                      <Button
                                        size="sm"
                                        color="danger"
                                        className="mt-4"
                                        onClick={() =>
                                          eliminarSubGrupo(a.id, index)
                                        }
                                      >
                                        <i className="fas fa-trash"></i>
                                      </Button>
                                    </Col>
                                  </Row>
                                )
                              )}

                              <Row className="mt-3 align-items-center">
                                <Col className="text-start">
                                  <Button
                                    size="sm"
                                    color="primary"
                                    onClick={() => agregarSubGrupo(a.id)}
                                  >
                                    <i className="fas fa-plus"></i> Agregar
                                    Talla
                                  </Button>
                                </Col>
                                <Col className="text-end">
                                  <Button
                                    size="sm"
                                    color="success"
                                    onClick={() =>
                                      guardarNuevoColaboradorConTallas(a.id)
                                    }
                                    disabled={
                                      !colaboradoresTallasNuevos[a.id] ||
                                      colaboradoresTallasNuevos[a.id].length ===
                                        0
                                    }
                                  >
                                    <i className="fas fa-save"></i> Guardar
                                    Tallas
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>

                    // </div>
                  ))}
                  <br />
                </>
              )}
              <h3>Editar</h3>
              {colaboradoresCliente
                .sort((a, b) => a.nombre.localeCompare(b.nombre))
                .map((a) => (
                  <>
                    <tr
                      style={
                        a.is_active === "No"
                          ? { backgroundColor: "#f8d7da" }
                          : {}
                      }
                    >
                      <td>
                        <Input
                          type="text"
                          name="numero"
                          value={a.numero}
                          key={a._id}
                          onChange={(e) => {
                            handleChangeInputColaboradoresExistentes(a._id, e);
                          }}
                        />{" "}
                        <small className="text-muted">Numero</small>
                      </td>
                      <td>
                        <Input
                          className="col-sm-12"
                          type="select"
                          name="selectedDepartamento"
                          value={a.selectedDepartamento || "0"}
                          required
                          onChange={(e) =>
                            handleChangeInputColaboradoresExistentes(a._id, e)
                          }
                        >
                          <option value="0">Selecciona</option>
                          {departamentos
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((dep) => (
                              <option key={dep._id} value={dep._id}>
                                {dep.name}
                              </option>
                            ))}
                        </Input>

                        <small className="text-muted">Departamento</small>
                      </td>
                      <td>
                        <Input
                          type="text"
                          name="nombre"
                          value={a.nombre}
                          key={a._id}
                          onChange={(e) => {
                            handleChangeInputColaboradoresExistentes(a._id, e);
                          }}
                        />
                        <small className="text-muted">Nombre</small>
                      </td>
                      {/* <td>
                        <Input
                          type="text"
                          name="estado"
                          value={a.estado}
                          required
                          onChange={(e) =>
                            handleChangeInputColaboradoresExistentes(a._id, e)
                          }
                        />
                          
                        <small className="text-muted">Estado</small>
                      </td> */}
                      <td>
                        <Input
                          className="col-sm-12"
                          type="select"
                          name="selectedSucursal"
                          value={a.selectedSucursal || "0"}
                          required
                          onChange={(e) =>
                            handleChangeInputColaboradoresExistentes(a._id, e)
                          }
                        >
                          <option value="0">Selecciona</option>
                          {sucursales
                            .sort((a, b) => (a.alias > b.alias ? 1 : -1))
                            .map((dep) => (
                              <option key={dep._id} value={dep._id}>
                                {dep.alias}
                              </option>
                            ))}
                        </Input>

                        <small className="text-muted">Sucursal</small>
                      </td>
                      <td>
                        <Input
                          className="col-sm-12"
                          type="select"
                          name="selectedArea"
                          value={a.selectedArea || "0"}
                          required
                          onChange={(e) =>
                            handleChangeInputColaboradoresExistentes(a._id, e)
                          }
                        >
                          <option value="0">Selecciona</option>
                          {areasClientes
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((area) => (
                              <option key={area._id} value={area._id}>
                                {area.name}
                              </option>
                            ))}
                        </Input>
                        <small className="text-muted">Área</small>
                      </td>

                      <td>
                        <Input
                          type="text"
                          name="telefono"
                          value={a.telefono}
                          key={a._id}
                          onChange={(e) => {
                            handleChangeInputColaboradoresExistentes(a._id, e);
                          }}
                        />
                        <small className="text-muted">Telefono</small>
                      </td>
                      <td>
                        <Button
                          size="sm"
                          color={
                            mostrarSubTallasEdit[a._id] ? "secondary" : "info"
                          }
                          onClick={() => toggleSubTallasEdit(a._id)}
                        >
                          <i className="fas fa-ruler-combined"></i>
                        </Button>
                        {a.is_active == "Si" ? (
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={() => bajaColaborador(a._id)}
                            tabindex="-1"
                          >
                            <i class="far fa-times-circle"></i>
                          </Button>
                        ) : (
                          <Button
                            size="sm"
                            className="btn"
                            color="primary"
                            onClick={() => altaColaborador(a._id)}
                            tabindex="-1"
                          >
                            <i class="far fa-check-circle"></i>
                          </Button>
                        )}
                      </td>
                    </tr>
                    {mostrarSubTallasEdit[a._id] && (
                      <tr>
                        <td colSpan="100%">
                          <div>
                            <h6 className="fw-bold">Tallas por Linea</h6>

                            {(colaboradoresTallasExistentes[a._id] || [])
                            .sort((a, b) => (a.subDepartamento > b.subDepartamento ? 1 : -1))
                            .map(
                              (grupo, index) => (
                                <Row
                                  key={index}
                                  className="align-items-center mb-2"
                                >
                                  <Col md={3}>
                                    <Label>Linea</Label>
                                    <Input
                                      type="select"
                                      value={grupo.subDepartamento}
                                      onChange={(e) =>
                                        actualizarSubGrupoEdit(
                                          a._id,
                                          index,
                                          "subDepartamento",
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="">Selecciona</option>
                                      {subDepartamentos
                                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                                      .map((s) => (
                                        <option key={s._id} value={s._id}>
                                          {s.name}
                                        </option>
                                      ))}
                                    </Input>
                                  </Col>
                                  <Col md={3}>
  <Label>Talla</Label>

  <Autocomplete
    size="small"
value={tallasOrdenadas.find(t => String(t._id) === String(grupo.talla)) || null}
options={tallasOrdenadas}
filterOptions={(options, params) => {
  const filtered = filter(options, params);
  const inputValue = String(params.inputValue || "").trim();

  if (inputValue) {
    const alreadyExists = tallasOrdenadas.some((opt) => {
      const base = String(opt?.name || opt?.nombre || "").trim().toLowerCase();
      return base === inputValue.toLowerCase();
    });

    if (!alreadyExists) {
      filtered.push({
        inputValue,
        title: `Dar de alta "${inputValue}"`,
      });
    }
  }

  return filtered;
}}
    getOptionLabel={(opt) => {
      if (typeof opt === "string") return opt;
      if (opt?.inputValue) return opt.inputValue;

      const base = String(opt?.name || opt?.nombre || "").trim();
      const varName = opt?.variantesTallas?.[0]?.name ? String(opt.variantesTallas[0].name).trim() : "";
      return varName ? `${base} ${varName}` : base;
    }}
    renderOption={(option) => {
      if (option?.title) return option.title;
      return (
        <span>
          {option?.name || option?.nombre}{" "}
          <span className="text-muted">{option?.variantesTallas?.[0]?.name || ""}</span>
        </span>
      );
    }}
    onChange={(e, newValue) => {
      if (!newValue) {
        actualizarSubGrupoEdit(a._id, index, "talla", "");
        return;
      }

      if (newValue?.inputValue) {
        openNuevaTalla("edit", a._id, index, newValue.inputValue);
        return;
      }

      if (typeof newValue === "string") {
        openNuevaTalla("edit", a._id, index, newValue);
        return;
      }

      actualizarSubGrupoEdit(a._id, index, "talla", newValue._id);
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Busca talla"
        variant="outlined"
        placeholder="Escribe para buscar o dar de alta"
      />
    )}
  />
</Col>
<Col md={3}>
                                      <Label>Observaciones</Label>
                                      <Input
                                        type="text"
                                        value={grupo.observaciones}
                                        onChange={(e) =>
                                          actualizarSubGrupoEdit(
                                            a._id,
                                            index,
                                            "observaciones",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Col>
                                  <Col md={2}>
                                    <Button
                                      size="sm"
                                      color="danger"
                                      className="mt-4"
                                      onClick={() =>
                                        eliminarSubGrupoEdit(a._id, index)
                                      }
                                    >
                                      <i className="fas fa-trash"></i>
                                    </Button>
                                  </Col>
                                </Row>
                              )
                            )}

                            <Button
                              size="sm"
                              color="primary"
                              onClick={() => agregarSubGrupoEdit(a._id)}
                            >
                              <i className="fas fa-plus"></i>
                            </Button>
                          </div>
                        </td>
                      </tr>
                    )}
                  </>
                  // </div>
                ))}
            </tbody>
            <br />
          </Table>
          <br />
          <Row>
            <Button className="btn btn-success" onClick={saveColaboradores}>
              Registrar
            </Button>
          </Row>
        </ModalBody>
      </Modal>


      <Modal size="lg" isOpen={modalArchivo} toggle={toggleArchivo}>
        <ModalHeader toggle={toggleArchivo}>
          <h4>Archivo Colaboradores</h4>
        </ModalHeader>
        <ModalBody>
 <Row>
  <Col md={6}>
  <Label>Selecciona Sucursal</Label>
  <Input
                          className="col-sm-12"
                          type="select"
                          name="selectedSucursal"
                          value={selectedSucursal}
                          required
                          onChange={(e) =>
                            setSelectedSucursal(e.target.value)
                          }
                        >
                          <option value="0">Selecciona</option>
                          {sucursales
                            .sort((a, b) => (a.alias > b.alias ? 1 : -1))
                            .map((dep) => (
                              <option key={dep._id} value={dep._id}>
                                {dep.alias}
                              </option>
                            ))}
                        </Input>
  </Col>
              <Col md={6}>
            <Label>Archivo</Label>
              <Input
                required
                type="file"
                name="file"
                id="file"
                onChange={(event) => importarArchivo(event)}
              />
            </Col>
            
            
            
          </Row>
    <Table bordered responsive size="sm" className="mt-3">
      <thead>
        <tr>
          <th>Número</th>
          <th>Departamento</th>
          <th>Nombre</th>
          <th>Estado</th>
          <th>Área</th>
          <th>Teléfono</th>
        </tr>
      </thead>
      <tbody>
        {inputFieldsColaboradores
          .filter((colab) => colab.nombre?.trim() !== "")
          .map((colab) => (
            <tr key={colab.id}>
              <td>{colab.numero}</td>
              <td>
                {
                  departamentos.find((d) => d._id === colab.departamentos)
                    ?.name || "-"
                }
              </td>
              <td>{colab.nombre}</td>
              <td>{colab.estado}</td>
              <td>
                {
                  areasClientes.find((a) => a._id === colab.areasClientes)
                    ?.name || "-"
                }
              </td>
              <td>{colab.telefono}</td>
            </tr>
          ))}
      </tbody>
    </Table>

          <br />
          <Row>
            <Button className="btn btn-success" onClick={saveColaboradoresArchivo}>
              Registrar
            </Button>
          </Row>
        </ModalBody>
      </Modal>

 <Modal
        isOpen={modalSucursalesOpen}
        toggle={toggleModalSucursales}
        size="xl"
        centered
      >
        <ModalHeader toggle={toggleModalSucursales}>
          Sucursales detectadas{" "}
          <Badge className="ms-2" color="secondary">
            {resumen.total}
          </Badge>
          {resumen.sinAlias > 0 && (
            <Badge className="ms-2" color="warning">
              Sin Alias: {resumen.sinAlias}
            </Badge>
          )}
        </ModalHeader>

        <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {inputFieldsSucArchivo.length === 0 ? (
            <div>No se encontró información en la primera hoja.</div>
          ) : (
            <Table bordered responsive hover size="sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Alias</th>
                  <th>Responsable</th>
                  <th>Ciudad</th>
                  <th>Estado</th>
                  <th>CP</th>
                  <th>Calle</th>
                  <th>No. Ext</th>
                  <th>No. Int</th>
                  <th>Colonia</th>
                  <th>Delegación</th>
                  <th>País</th>
                  <th>RFC</th>
                  <th>Razón Social</th>
                  <th>Reg Fiscal</th>
                </tr>
              </thead>
              <tbody>
                {inputFieldsSucArchivo.map((s, idx) => {
                  const aliasOk = String(s.alias || "").trim().length > 0;

                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>
                        {aliasOk ? (
                          s.alias
                        ) : (
                          <Badge color="danger">Falta Alias</Badge>
                        )}
                      </td>
                      <td>{s.responsable}</td>
                      <td>{s.ciudad}</td>
                      <td>{s.estado}</td>
                      <td>{s.cp}</td>
                      <td>{s.calle}</td>
                      <td>{s.numero_ext}</td>
                      <td>{s.numero_int}</td>
                      <td>{s.colonia}</td>
                      <td>{s.delegacion}</td>
                      <td>{s.pais}</td>
                      <td>{s.RFC}</td>
                      <td>{s.razon_social}</td>
                      <td>{s.regFiscal}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </ModalBody>

        <ModalFooter>
          {/* <Button color="secondary" onClick={toggleModalSucursales}>
            Cerrar
          </Button> */}

           <Button color="secondary" onClick={saveSucursalesArchivo}>
            Guardar
          </Button>

        </ModalFooter>
      </Modal>

      <Modal isOpen={modalNuevaTalla} toggle={() => setModalNuevaTalla(!modalNuevaTalla)}>
  <ModalHeader toggle={() => setModalNuevaTalla(!modalNuevaTalla)}>
    Dar de alta talla
  </ModalHeader>
  <ModalBody>
    <FormGroup>
      <Label>Nombre de la talla</Label>
      <Input
        value={nuevaTallaNombre}
        onChange={(e) => setNuevaTallaNombre(e.target.value)}
        placeholder='Ej. "2XG", "CH", "30", etc.'
      />

      <Label className="mt-2">Variante</Label>
      <Input
        type="select"
        value={variante}
        onChange={(e) => setVariante(e.target.value)}
      >
        <option value="0">Selecciona</option>
        {(variantesTallas || [])
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .map((v) => (
            <option key={v._id} value={v._id}>
              {v.name}
            </option>
          ))}
      </Input>
    </FormGroup>

    <div className="d-flex gap-2">
      <Button
        color="primary"
        onClick={guardarNuevaTalla}
        disabled={savingTalla || !String(nuevaTallaNombre || "").trim()}
      >
        {savingTalla ? "Guardando..." : "Guardar"}
      </Button>

      <Button
        color="secondary"
        onClick={() => setModalNuevaTalla(false)}
        disabled={savingTalla}
      >
        Cancelar
      </Button>
    </div>
  </ModalBody>
</Modal>



<Modal size="xxl" isOpen={modalArchivoTallas} toggle={toggleArchivoTallas}>
  <ModalHeader toggle={toggleArchivoTallas}>
    <h4>Archivo Tallas Colaboradores</h4>
  </ModalHeader>

  <ModalBody>
    <Row>
      <Col md={6}>
        <Label>Archivo</Label>
        <Input
  type="file"
  disabled={
    !idClienteCol ||
    !areas?.length ||
    !tallas?.length ||
    !sucursales?.length ||
    !departamentos?.length ||
    !subDepartamentos?.length
  }
  onChange={importarArchivoTallas}
/>
      </Col>
    </Row>

    <br />

    <Row>
      <Col md={12}>
        <Table bordered responsive size="sm">
          <thead>
            <tr>
              <th>#</th>
              <th>Sucursal</th>
              <th>Área</th>
              <th>Departamento</th>
              <th>Nombre</th>
              <th>Estado</th>
              <th>Teléfono</th>
              <th>Número</th>
              <th>Tallas</th>
              <th>Estatus</th>
            </tr>
          </thead>

          <tbody>
            {(colaboradoresImportar || []).length > 0 ? (
              colaboradoresImportar.map((colab, index) => {
                const okGeneral =
                  colab.nombre?.trim() !== "" &&
                  colab.sucursalId &&
                  colab.areaId &&
                  colab.departamentoId;

                return (
                  <tr key={index}>
                    <td>{index + 1}</td>

                    <td>
                      {colab.sucursal || "-"}
                      {!colab.sucursalId && colab.sucursal ? (
                        <div style={{ color: "red", fontSize: "12px" }}>
                          No encontrada
                        </div>
                      ) : null}
                    </td>

                    <td>
                      {colab.area || "-"}
                      {!colab.areaId && colab.area ? (
                        <div style={{ color: "red", fontSize: "12px" }}>
                          No encontrada
                        </div>
                      ) : null}
                    </td>

                    <td>
                      {colab.departamento || "-"}
                      {!colab.departamentoId && colab.departamento ? (
                        <div style={{ color: "red", fontSize: "12px" }}>
                          No encontrado
                        </div>
                      ) : null}
                    </td>

                    <td>{colab.nombre || "-"}</td>
                    <td>{colab.estado || "-"}</td>
                    <td>{colab.telefono || "-"}</td>
                    <td>{colab.numero || "-"}</td>

                    <td style={{ minWidth: "260px" }}>
                      {colab.tallas && colab.tallas.length > 0 ? (
                        <div>
                          {colab.tallas.map((t, i) => (
                            <div key={i} style={{ marginBottom: "4px" }}>
                              <b>{t.subDepartamento}:</b> {t.tallaTexto}
                              {!t.tallaId ? (
                                <span style={{ color: "red", marginLeft: "6px" }}>
                                  (No encontrada)
                                </span>
                              ) : null}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span style={{ color: "#999" }}>Sin tallas</span>
                      )}
                    </td>

                    <td>
                      {okGeneral ? (
                        <span style={{ color: "green", fontWeight: 600 }}>
                          Listo
                        </span>
                      ) : (
                        <span style={{ color: "red", fontWeight: 600 }}>
                          Revisar
                        </span>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="10" className="text-center">
                  No hay datos cargados
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Col>
    </Row>

    <br />

    <Row>
      <Col md={12} className="d-flex gap-2">
        <Button
          className="btn btn-success"
          onClick={saveImportacionTallas}
          disabled={!colaboradoresImportar || colaboradoresImportar.length === 0}
        >
          Registrar
        </Button>
      </Col>
    </Row>
  </ModalBody>
</Modal>

<Modal size="xxl" isOpen={modalAreas} toggle={toggleModalAreas}>
  <ModalHeader toggle={toggleModalAreas}>Áreas del cliente</ModalHeader>
  <ModalBody>
    <ListadoAreasClientes
      selectedCliente={selectedClienteAreas}
      onAreaCreated={(nuevaArea) => {
        if (nuevaArea && nuevaArea._id) {
          setAreasClientes((prev) => [...(prev || []), nuevaArea]);
        }
      }}
    />
  </ModalBody>
</Modal>
      {loader}
    </>
  );
}

export default ListadoClientes;
